var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import React, { memo, useState, useEffect, isValidElement, createElement, Component } from "react";
import { css, cx } from "@emotion/css";
function getDefaultExportFromCjs$1(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var browser = { exports: {} };
var process = browser.exports = {};
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
  throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    if (typeof setTimeout === "function") {
      cachedSetTimeout = setTimeout;
    } else {
      cachedSetTimeout = defaultSetTimout;
    }
  } catch (e) {
    cachedSetTimeout = defaultSetTimout;
  }
  try {
    if (typeof clearTimeout === "function") {
      cachedClearTimeout = clearTimeout;
    } else {
      cachedClearTimeout = defaultClearTimeout;
    }
  } catch (e) {
    cachedClearTimeout = defaultClearTimeout;
  }
})();
function runTimeout(fun) {
  if (cachedSetTimeout === setTimeout) {
    return setTimeout(fun, 0);
  }
  if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
    cachedSetTimeout = setTimeout;
    return setTimeout(fun, 0);
  }
  try {
    return cachedSetTimeout(fun, 0);
  } catch (e) {
    try {
      return cachedSetTimeout.call(null, fun, 0);
    } catch (e2) {
      return cachedSetTimeout.call(this, fun, 0);
    }
  }
}
function runClearTimeout(marker) {
  if (cachedClearTimeout === clearTimeout) {
    return clearTimeout(marker);
  }
  if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
    cachedClearTimeout = clearTimeout;
    return clearTimeout(marker);
  }
  try {
    return cachedClearTimeout(marker);
  } catch (e) {
    try {
      return cachedClearTimeout.call(null, marker);
    } catch (e2) {
      return cachedClearTimeout.call(this, marker);
    }
  }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
  if (!draining || !currentQueue) {
    return;
  }
  draining = false;
  if (currentQueue.length) {
    queue = currentQueue.concat(queue);
  } else {
    queueIndex = -1;
  }
  if (queue.length) {
    drainQueue();
  }
}
function drainQueue() {
  if (draining) {
    return;
  }
  var timeout = runTimeout(cleanUpNextTick);
  draining = true;
  var len = queue.length;
  while (len) {
    currentQueue = queue;
    queue = [];
    while (++queueIndex < len) {
      if (currentQueue) {
        currentQueue[queueIndex].run();
      }
    }
    queueIndex = -1;
    len = queue.length;
  }
  currentQueue = null;
  draining = false;
  runClearTimeout(timeout);
}
process.nextTick = function(fun) {
  var args = new Array(arguments.length - 1);
  if (arguments.length > 1) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      args[i2 - 1] = arguments[i2];
    }
  }
  queue.push(new Item(fun, args));
  if (queue.length === 1 && !draining) {
    runTimeout(drainQueue);
  }
};
function Item(fun, array) {
  this.fun = fun;
  this.array = array;
}
Item.prototype.run = function() {
  this.fun.apply(null, this.array);
};
process.title = "browser";
process.browser = true;
process.env = {};
process.argv = [];
process.version = "";
process.versions = {};
function noop() {
}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
  return [];
};
process.binding = function(name) {
  throw new Error("process.binding is not supported");
};
process.cwd = function() {
  return "/";
};
process.chdir = function(dir) {
  throw new Error("process.chdir is not supported");
};
process.umask = function() {
  return 0;
};
var browserExports = browser.exports;
const process$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(browserExports);
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var propTypes = { exports: {} };
var reactIs = { exports: {} };
var reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min)
    return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k2 = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m2 = b ? Symbol.for("react.concurrent_mode") : 60111, n2 = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t2 = b ? Symbol.for("react.lazy") : 60116, v2 = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
  function z(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;
      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m2:
            case e:
            case g:
            case f:
            case p:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case k2:
                case n2:
                case t2:
                case r:
                case h:
                  return a;
                default:
                  return u;
              }
          }
        case d:
          return u;
      }
    }
  }
  function A(a) {
    return z(a) === m2;
  }
  reactIs_production_min.AsyncMode = l;
  reactIs_production_min.ConcurrentMode = m2;
  reactIs_production_min.ContextConsumer = k2;
  reactIs_production_min.ContextProvider = h;
  reactIs_production_min.Element = c;
  reactIs_production_min.ForwardRef = n2;
  reactIs_production_min.Fragment = e;
  reactIs_production_min.Lazy = t2;
  reactIs_production_min.Memo = r;
  reactIs_production_min.Portal = d;
  reactIs_production_min.Profiler = g;
  reactIs_production_min.StrictMode = f;
  reactIs_production_min.Suspense = p;
  reactIs_production_min.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
  };
  reactIs_production_min.isConcurrentMode = A;
  reactIs_production_min.isContextConsumer = function(a) {
    return z(a) === k2;
  };
  reactIs_production_min.isContextProvider = function(a) {
    return z(a) === h;
  };
  reactIs_production_min.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
  };
  reactIs_production_min.isForwardRef = function(a) {
    return z(a) === n2;
  };
  reactIs_production_min.isFragment = function(a) {
    return z(a) === e;
  };
  reactIs_production_min.isLazy = function(a) {
    return z(a) === t2;
  };
  reactIs_production_min.isMemo = function(a) {
    return z(a) === r;
  };
  reactIs_production_min.isPortal = function(a) {
    return z(a) === d;
  };
  reactIs_production_min.isProfiler = function(a) {
    return z(a) === g;
  };
  reactIs_production_min.isStrictMode = function(a) {
    return z(a) === f;
  };
  reactIs_production_min.isSuspense = function(a) {
    return z(a) === p;
  };
  reactIs_production_min.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m2 || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t2 || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k2 || a.$$typeof === n2 || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v2);
  };
  reactIs_production_min.typeOf = z;
  return reactIs_production_min;
}
var reactIs_development = {};
var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development)
    return reactIs_development;
  hasRequiredReactIs_development = 1;
  if (process$1.env.NODE_ENV !== "production") {
    (function() {
      var hasSymbol = typeof Symbol === "function" && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
      function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === "object" && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development.AsyncMode = AsyncMode;
      reactIs_development.ConcurrentMode = ConcurrentMode;
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element;
      reactIs_development.ForwardRef = ForwardRef;
      reactIs_development.Fragment = Fragment;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf;
    })();
  }
  return reactIs_development;
}
var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs)
    return reactIs.exports;
  hasRequiredReactIs = 1;
  if (process$1.env.NODE_ENV === "production") {
    reactIs.exports = requireReactIs_production_min();
  } else {
    reactIs.exports = requireReactIs_development();
  }
  return reactIs.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign;
var hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign)
    return objectAssign;
  hasRequiredObjectAssign = 1;
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject(val) {
    if (val === null || val === void 0) {
      throw new TypeError("Object.assign cannot be called with null or undefined");
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }
      var test1 = new String("abc");
      test1[5] = "de";
      if (Object.getOwnPropertyNames(test1)[0] === "5") {
        return false;
      }
      var test2 = {};
      for (var i2 = 0; i2 < 10; i2++) {
        test2["_" + String.fromCharCode(i2)] = i2;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function(n2) {
        return test2[n2];
      });
      if (order2.join("") !== "0123456789") {
        return false;
      }
      var test3 = {};
      "abcdefghijklmnopqrst".split("").forEach(function(letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
        return false;
      }
      return true;
    } catch (err) {
      return false;
    }
  }
  objectAssign = shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for (var s2 = 1; s2 < arguments.length; s2++) {
      from = Object(arguments[s2]);
      for (var key in from) {
        if (hasOwnProperty.call(from, key)) {
          to[key] = from[key];
        }
      }
      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);
        for (var i2 = 0; i2 < symbols.length; i2++) {
          if (propIsEnumerable.call(from, symbols[i2])) {
            to[symbols[i2]] = from[symbols[i2]];
          }
        }
      }
    }
    return to;
  };
  return objectAssign;
}
var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret)
    return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1;
}
var has;
var hasRequiredHas;
function requireHas() {
  if (hasRequiredHas)
    return has;
  hasRequiredHas = 1;
  has = Function.call.bind(Object.prototype.hasOwnProperty);
  return has;
}
var checkPropTypes_1;
var hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes)
    return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var printWarning = function() {
  };
  if (process$1.env.NODE_ENV !== "production") {
    var ReactPropTypesSecret = requireReactPropTypesSecret();
    var loggedTypeFailures = {};
    var has2 = requireHas();
    printWarning = function(text) {
      var message2 = "Warning: " + text;
      if (typeof console !== "undefined") {
        console.error(message2);
      }
      try {
        throw new Error(message2);
      } catch (x) {
      }
    };
  }
  function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    if (process$1.env.NODE_ENV !== "production") {
      for (var typeSpecName in typeSpecs) {
        if (has2(typeSpecs, typeSpecName)) {
          var error;
          try {
            if (typeof typeSpecs[typeSpecName] !== "function") {
              var err = Error(
                (componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              err.name = "Invariant Violation";
              throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
          } catch (ex) {
            error = ex;
          }
          if (error && !(error instanceof Error)) {
            printWarning(
              (componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
            );
          }
          if (error instanceof Error && !(error.message in loggedTypeFailures)) {
            loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : "";
            printWarning(
              "Failed " + location + " type: " + error.message + (stack != null ? stack : "")
            );
          }
        }
      }
    }
  }
  checkPropTypes.resetWarningCache = function() {
    if (process$1.env.NODE_ENV !== "production") {
      loggedTypeFailures = {};
    }
  };
  checkPropTypes_1 = checkPropTypes;
  return checkPropTypes_1;
}
var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers)
    return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var ReactIs = requireReactIs();
  var assign = requireObjectAssign();
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  var has2 = requireHas();
  var checkPropTypes = requireCheckPropTypes();
  var printWarning = function() {
  };
  if (process$1.env.NODE_ENV !== "production") {
    printWarning = function(text) {
      var message2 = "Warning: " + text;
      if (typeof console !== "undefined") {
        console.error(message2);
      }
      try {
        throw new Error(message2);
      } catch (x) {
      }
    };
  }
  function emptyFunctionThatReturnsNull() {
    return null;
  }
  factoryWithTypeCheckers = function(isValidElement2, throwOnDirectAccess) {
    var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === "function") {
        return iteratorFn;
      }
    }
    var ANONYMOUS = "<<anonymous>>";
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker("array"),
      bigint: createPrimitiveTypeChecker("bigint"),
      bool: createPrimitiveTypeChecker("boolean"),
      func: createPrimitiveTypeChecker("function"),
      number: createPrimitiveTypeChecker("number"),
      object: createPrimitiveTypeChecker("object"),
      string: createPrimitiveTypeChecker("string"),
      symbol: createPrimitiveTypeChecker("symbol"),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };
    function is(x, y) {
      if (x === y) {
        return x !== 0 || 1 / x === 1 / y;
      } else {
        return x !== x && y !== y;
      }
    }
    function PropTypeError(message2, data) {
      this.message = message2;
      this.data = data && typeof data === "object" ? data : {};
      this.stack = "";
    }
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
      if (process$1.env.NODE_ENV !== "production") {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        if (secret !== ReactPropTypesSecret) {
          if (throwOnDirectAccess) {
            var err = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            err.name = "Invariant Violation";
            throw err;
          } else if (process$1.env.NODE_ENV !== "production" && typeof console !== "undefined") {
            var cacheKey = componentName + ":" + propName;
            if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3) {
              printWarning(
                "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
              );
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
            }
            return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
          }
          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }
      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          var preciseType = getPreciseType(propValue);
          return new PropTypeError(
            "Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
            { expectedType }
          );
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
        }
        for (var i2 = 0; i2 < propValue.length; i2++) {
          var error = typeChecker(propValue, i2, componentName, location, propFullName + "[" + i2 + "]", ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!isValidElement2(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!ReactIs.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process$1.env.NODE_ENV !== "production") {
          if (arguments.length > 1) {
            printWarning(
              "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
            );
          } else {
            printWarning("Invalid argument supplied to oneOf, expected an array.");
          }
        }
        return emptyFunctionThatReturnsNull;
      }
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        for (var i2 = 0; i2 < expectedValues.length; i2++) {
          if (is(propValue, expectedValues[i2])) {
            return null;
          }
        }
        var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
          var type = getPreciseType(value);
          if (type === "symbol") {
            return String(value);
          }
          return value;
        });
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
        }
        for (var key in propValue) {
          if (has2(propValue, key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process$1.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
        return emptyFunctionThatReturnsNull;
      }
      for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
        var checker = arrayOfTypeCheckers[i2];
        if (typeof checker !== "function") {
          printWarning(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i2 + "."
          );
          return emptyFunctionThatReturnsNull;
        }
      }
      function validate(props, propName, componentName, location, propFullName) {
        var expectedTypes = [];
        for (var i3 = 0; i3 < arrayOfTypeCheckers.length; i3++) {
          var checker2 = arrayOfTypeCheckers[i3];
          var checkerResult = checker2(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
          if (checkerResult == null) {
            return null;
          }
          if (checkerResult.data && has2(checkerResult.data, "expectedType")) {
            expectedTypes.push(checkerResult.data.expectedType);
          }
        }
        var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode(props[propName])) {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
      return new PropTypeError(
        (componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`."
      );
    }
    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        var allKeys = assign({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (has2(shapeTypes, key) && typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          if (!checker) {
            return new PropTypeError(
              "Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
            );
          }
          var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
      switch (typeof propValue) {
        case "number":
        case "string":
        case "undefined":
          return true;
        case "boolean":
          return !propValue;
        case "object":
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }
          if (propValue === null || isValidElement2(propValue)) {
            return true;
          }
          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode(step.value)) {
                  return false;
                }
              }
            } else {
              while (!(step = iterator.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }
          return true;
        default:
          return false;
      }
    }
    function isSymbol(propType, propValue) {
      if (propType === "symbol") {
        return true;
      }
      if (!propValue) {
        return false;
      }
      if (propValue["@@toStringTag"] === "Symbol") {
        return true;
      }
      if (typeof Symbol === "function" && propValue instanceof Symbol) {
        return true;
      }
      return false;
    }
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return "array";
      }
      if (propValue instanceof RegExp) {
        return "object";
      }
      if (isSymbol(propType, propValue)) {
        return "symbol";
      }
      return propType;
    }
    function getPreciseType(propValue) {
      if (typeof propValue === "undefined" || propValue === null) {
        return "" + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === "object") {
        if (propValue instanceof Date) {
          return "date";
        } else if (propValue instanceof RegExp) {
          return "regexp";
        }
      }
      return propType;
    }
    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);
      switch (type) {
        case "array":
        case "object":
          return "an " + type;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + type;
        default:
          return type;
      }
    }
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithTypeCheckers;
}
var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims)
    return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  function emptyFunction() {
  }
  function emptyFunctionWithReset() {
  }
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  factoryWithThrowingShims = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        return;
      }
      var err = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      err.name = "Invariant Violation";
      throw err;
    }
    shim.isRequired = shim;
    function getShim() {
      return shim;
    }
    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithThrowingShims;
}
if (process$1.env.NODE_ENV !== "production") {
  var ReactIs = requireReactIs();
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  propTypes.exports = requireFactoryWithThrowingShims()();
}
var propTypesExports = propTypes.exports;
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
function toDate(argument) {
  const argStr = Object.prototype.toString.call(argument);
  if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") {
    return new argument.constructor(+argument);
  } else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") {
    return new Date(argument);
  } else {
    return /* @__PURE__ */ new Date(NaN);
  }
}
function constructFrom(date, value) {
  if (date instanceof Date) {
    return new date.constructor(value);
  } else {
    return new Date(value);
  }
}
function addDays(date, amount) {
  const _date = toDate(date);
  if (isNaN(amount))
    return constructFrom(date, NaN);
  if (!amount) {
    return _date;
  }
  _date.setDate(_date.getDate() + amount);
  return _date;
}
function addMonths(date, amount) {
  const _date = toDate(date);
  if (isNaN(amount))
    return constructFrom(date, NaN);
  if (!amount) {
    return _date;
  }
  const dayOfMonth = _date.getDate();
  const endOfDesiredMonth = constructFrom(date, _date.getTime());
  endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
  const daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    return endOfDesiredMonth;
  } else {
    _date.setFullYear(
      endOfDesiredMonth.getFullYear(),
      endOfDesiredMonth.getMonth(),
      dayOfMonth
    );
    return _date;
  }
}
function addWeeks(date, amount) {
  const days = amount * 7;
  return addDays(date, days);
}
const millisecondsInWeek = 6048e5;
const millisecondsInDay = 864e5;
const millisecondsInMinute = 6e4;
const millisecondsInHour = 36e5;
let defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function startOfWeek(date, options) {
  var _a, _b, _c, _d;
  const defaultOptions2 = getDefaultOptions();
  const weekStartsOn = (options == null ? void 0 : options.weekStartsOn) ?? ((_b = (_a = options == null ? void 0 : options.locale) == null ? void 0 : _a.options) == null ? void 0 : _b.weekStartsOn) ?? defaultOptions2.weekStartsOn ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.weekStartsOn) ?? 0;
  const _date = toDate(date);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  _date.setDate(_date.getDate() - diff);
  _date.setHours(0, 0, 0, 0);
  return _date;
}
function getTimezoneOffsetInMilliseconds(date) {
  const _date = toDate(date);
  const utcDate = new Date(
    Date.UTC(
      _date.getFullYear(),
      _date.getMonth(),
      _date.getDate(),
      _date.getHours(),
      _date.getMinutes(),
      _date.getSeconds(),
      _date.getMilliseconds()
    )
  );
  utcDate.setUTCFullYear(_date.getFullYear());
  return +date - +utcDate;
}
function differenceInCalendarWeeks(dateLeft, dateRight, options) {
  const startOfWeekLeft = startOfWeek(dateLeft, options);
  const startOfWeekRight = startOfWeek(dateRight, options);
  const timestampLeft = +startOfWeekLeft - getTimezoneOffsetInMilliseconds(startOfWeekLeft);
  const timestampRight = +startOfWeekRight - getTimezoneOffsetInMilliseconds(startOfWeekRight);
  return Math.round((timestampLeft - timestampRight) / millisecondsInWeek);
}
function endOfDay(date) {
  const _date = toDate(date);
  _date.setHours(23, 59, 59, 999);
  return _date;
}
const formatDistanceLocale = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
};
const formatDistance = (token, count, options) => {
  let result;
  const tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }
  if (options == null ? void 0 : options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      return result + " ago";
    }
  }
  return result;
};
function buildFormatLongFn(args) {
  return (options = {}) => {
    const width = options.width ? String(options.width) : args.defaultWidth;
    const format2 = args.formats[width] || args.formats[args.defaultWidth];
    return format2;
  };
}
const dateFormats = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
};
const timeFormats = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
};
const dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
const formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
};
const formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
};
const formatRelative = (token, _date, _baseDate, _options) => formatRelativeLocale[token];
function buildLocalizeFn(args) {
  return (value, options) => {
    const context = (options == null ? void 0 : options.context) ? String(options.context) : "standalone";
    let valuesArray;
    if (context === "formatting" && args.formattingValues) {
      const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      const width = (options == null ? void 0 : options.width) ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      const defaultWidth = args.defaultWidth;
      const width = (options == null ? void 0 : options.width) ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[width] || args.values[defaultWidth];
    }
    const index = args.argumentCallback ? args.argumentCallback(value) : value;
    return valuesArray[index];
  };
}
const eraValues = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
};
const quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
};
const monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
};
const dayValues = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
};
const dayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
};
const formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
};
const ordinalNumber = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  const rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + "st";
      case 2:
        return number + "nd";
      case 3:
        return number + "rd";
    }
  }
  return number + "th";
};
const localize = {
  ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide"
  })
};
function buildMatchFn(args) {
  return (string, options = {}) => {
    const width = options.width;
    const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    const matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    const matchedString = matchResult[0];
    const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    const key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, (pattern) => pattern.test(matchedString)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      findKey(parsePatterns, (pattern) => pattern.test(matchedString))
    );
    let value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      options.valueCallback(value)
    ) : value;
    const rest = string.slice(matchedString.length);
    return { value, rest };
  };
}
function findKey(object, predicate) {
  for (const key in object) {
    if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) {
      return key;
    }
  }
  return void 0;
}
function findIndex(array, predicate) {
  for (let key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return void 0;
}
function buildMatchPatternFn(args) {
  return (string, options = {}) => {
    const matchResult = string.match(args.matchPattern);
    if (!matchResult)
      return null;
    const matchedString = matchResult[0];
    const parseResult = string.match(args.parsePattern);
    if (!parseResult)
      return null;
    let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    const rest = string.slice(matchedString.length);
    return { value, rest };
  };
}
const matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern = /\d+/i;
const matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
const parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
const matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
const parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
const matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const parseMonthPatterns = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
};
const matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
const matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
const match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: (value) => parseInt(value, 10)
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any"
  })
};
const enUS = {
  code: "en-US",
  formatDistance,
  formatLong,
  formatRelative,
  localize,
  match,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function startOfDay(date) {
  const _date = toDate(date);
  _date.setHours(0, 0, 0, 0);
  return _date;
}
function differenceInCalendarDays(dateLeft, dateRight) {
  const startOfDayLeft = startOfDay(dateLeft);
  const startOfDayRight = startOfDay(dateRight);
  const timestampLeft = +startOfDayLeft - getTimezoneOffsetInMilliseconds(startOfDayLeft);
  const timestampRight = +startOfDayRight - getTimezoneOffsetInMilliseconds(startOfDayRight);
  return Math.round((timestampLeft - timestampRight) / millisecondsInDay);
}
function startOfYear(date) {
  const cleanDate = toDate(date);
  const _date = constructFrom(date, 0);
  _date.setFullYear(cleanDate.getFullYear(), 0, 1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}
function getDayOfYear(date) {
  const _date = toDate(date);
  const diff = differenceInCalendarDays(_date, startOfYear(_date));
  const dayOfYear = diff + 1;
  return dayOfYear;
}
function startOfISOWeek(date) {
  return startOfWeek(date, { weekStartsOn: 1 });
}
function getISOWeekYear(date) {
  const _date = toDate(date);
  const year = _date.getFullYear();
  const fourthOfJanuaryOfNextYear = constructFrom(date, 0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);
  const fourthOfJanuaryOfThisYear = constructFrom(date, 0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);
  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfISOWeekYear(date) {
  const year = getISOWeekYear(date);
  const fourthOfJanuary = constructFrom(date, 0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  return startOfISOWeek(fourthOfJanuary);
}
function getISOWeek(date) {
  const _date = toDate(date);
  const diff = +startOfISOWeek(_date) - +startOfISOWeekYear(_date);
  return Math.round(diff / millisecondsInWeek) + 1;
}
function getWeekYear(date, options) {
  var _a, _b, _c, _d;
  const _date = toDate(date);
  const year = _date.getFullYear();
  const defaultOptions2 = getDefaultOptions();
  const firstWeekContainsDate = (options == null ? void 0 : options.firstWeekContainsDate) ?? ((_b = (_a = options == null ? void 0 : options.locale) == null ? void 0 : _a.options) == null ? void 0 : _b.firstWeekContainsDate) ?? defaultOptions2.firstWeekContainsDate ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.firstWeekContainsDate) ?? 1;
  const firstWeekOfNextYear = constructFrom(date, 0);
  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfWeek(firstWeekOfNextYear, options);
  const firstWeekOfThisYear = constructFrom(date, 0);
  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfWeek(firstWeekOfThisYear, options);
  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfWeekYear(date, options) {
  var _a, _b, _c, _d;
  const defaultOptions2 = getDefaultOptions();
  const firstWeekContainsDate = (options == null ? void 0 : options.firstWeekContainsDate) ?? ((_b = (_a = options == null ? void 0 : options.locale) == null ? void 0 : _a.options) == null ? void 0 : _b.firstWeekContainsDate) ?? defaultOptions2.firstWeekContainsDate ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.firstWeekContainsDate) ?? 1;
  const year = getWeekYear(date, options);
  const firstWeek = constructFrom(date, 0);
  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  const _date = startOfWeek(firstWeek, options);
  return _date;
}
function getWeek(date, options) {
  const _date = toDate(date);
  const diff = +startOfWeek(_date, options) - +startOfWeekYear(_date, options);
  return Math.round(diff / millisecondsInWeek) + 1;
}
function addLeadingZeros(number, targetLength) {
  const sign = number < 0 ? "-" : "";
  const output = Math.abs(number).toString().padStart(targetLength, "0");
  return sign + output;
}
const lightFormatters = {
  // Year
  y(date, token) {
    const signedYear = date.getFullYear();
    const year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === "yy" ? year % 100 : year, token.length);
  },
  // Month
  M(date, token) {
    const month = date.getMonth();
    return token === "M" ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d(date, token) {
    return addLeadingZeros(date.getDate(), token.length);
  },
  // AM or PM
  a(date, token) {
    const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(date, token) {
    return addLeadingZeros(date.getHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H(date, token) {
    return addLeadingZeros(date.getHours(), token.length);
  },
  // Minute
  m(date, token) {
    return addLeadingZeros(date.getMinutes(), token.length);
  },
  // Second
  s(date, token) {
    return addLeadingZeros(date.getSeconds(), token.length);
  },
  // Fraction of second
  S(date, token) {
    const numberOfDigits = token.length;
    const milliseconds = date.getMilliseconds();
    const fractionalSeconds = Math.trunc(
      milliseconds * Math.pow(10, numberOfDigits - 3)
    );
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
const dayPeriodEnum = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
};
const formatters = {
  // Era
  G: function(date, token, localize2) {
    const era = date.getFullYear() > 0 ? 1 : 0;
    switch (token) {
      case "G":
      case "GG":
      case "GGG":
        return localize2.era(era, { width: "abbreviated" });
      case "GGGGG":
        return localize2.era(era, { width: "narrow" });
      case "GGGG":
      default:
        return localize2.era(era, { width: "wide" });
    }
  },
  // Year
  y: function(date, token, localize2) {
    if (token === "yo") {
      const signedYear = date.getFullYear();
      const year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize2.ordinalNumber(year, { unit: "year" });
    }
    return lightFormatters.y(date, token);
  },
  // Local week-numbering year
  Y: function(date, token, localize2, options) {
    const signedWeekYear = getWeekYear(date, options);
    const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
    if (token === "YY") {
      const twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }
    if (token === "Yo") {
      return localize2.ordinalNumber(weekYear, { unit: "year" });
    }
    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function(date, token) {
    const isoWeekYear = getISOWeekYear(date);
    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(date, token) {
    const year = date.getFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function(date, token, localize2) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token) {
      case "Q":
        return String(quarter);
      case "QQ":
        return addLeadingZeros(quarter, 2);
      case "Qo":
        return localize2.ordinalNumber(quarter, { unit: "quarter" });
      case "QQQ":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(date, token, localize2) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token) {
      case "q":
        return String(quarter);
      case "qq":
        return addLeadingZeros(quarter, 2);
      case "qo":
        return localize2.ordinalNumber(quarter, { unit: "quarter" });
      case "qqq":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(date, token, localize2) {
    const month = date.getMonth();
    switch (token) {
      case "M":
      case "MM":
        return lightFormatters.M(date, token);
      case "Mo":
        return localize2.ordinalNumber(month + 1, { unit: "month" });
      case "MMM":
        return localize2.month(month, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return localize2.month(month, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return localize2.month(month, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(date, token, localize2) {
    const month = date.getMonth();
    switch (token) {
      case "L":
        return String(month + 1);
      case "LL":
        return addLeadingZeros(month + 1, 2);
      case "Lo":
        return localize2.ordinalNumber(month + 1, { unit: "month" });
      case "LLL":
        return localize2.month(month, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return localize2.month(month, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return localize2.month(month, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(date, token, localize2, options) {
    const week = getWeek(date, options);
    if (token === "wo") {
      return localize2.ordinalNumber(week, { unit: "week" });
    }
    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function(date, token, localize2) {
    const isoWeek = getISOWeek(date);
    if (token === "Io") {
      return localize2.ordinalNumber(isoWeek, { unit: "week" });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function(date, token, localize2) {
    if (token === "do") {
      return localize2.ordinalNumber(date.getDate(), { unit: "date" });
    }
    return lightFormatters.d(date, token);
  },
  // Day of year
  D: function(date, token, localize2) {
    const dayOfYear = getDayOfYear(date);
    if (token === "Do") {
      return localize2.ordinalNumber(dayOfYear, { unit: "dayOfYear" });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function(date, token, localize2) {
    const dayOfWeek = date.getDay();
    switch (token) {
      case "E":
      case "EE":
      case "EEE":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(date, token, localize2, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case "e":
        return String(localDayOfWeek);
      case "ee":
        return addLeadingZeros(localDayOfWeek, 2);
      case "eo":
        return localize2.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "eee":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(date, token, localize2, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case "c":
        return String(localDayOfWeek);
      case "cc":
        return addLeadingZeros(localDayOfWeek, token.length);
      case "co":
        return localize2.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "ccc":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(date, token, localize2) {
    const dayOfWeek = date.getDay();
    const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      case "i":
        return String(isoDayOfWeek);
      case "ii":
        return addLeadingZeros(isoDayOfWeek, token.length);
      case "io":
        return localize2.ordinalNumber(isoDayOfWeek, { unit: "day" });
      case "iii":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(date, token, localize2) {
    const hours = date.getHours();
    const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(date, token, localize2) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    }
    switch (token) {
      case "b":
      case "bb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(date, token, localize2) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(date, token, localize2) {
    if (token === "ho") {
      let hours = date.getHours() % 12;
      if (hours === 0)
        hours = 12;
      return localize2.ordinalNumber(hours, { unit: "hour" });
    }
    return lightFormatters.h(date, token);
  },
  // Hour [0-23]
  H: function(date, token, localize2) {
    if (token === "Ho") {
      return localize2.ordinalNumber(date.getHours(), { unit: "hour" });
    }
    return lightFormatters.H(date, token);
  },
  // Hour [0-11]
  K: function(date, token, localize2) {
    const hours = date.getHours() % 12;
    if (token === "Ko") {
      return localize2.ordinalNumber(hours, { unit: "hour" });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function(date, token, localize2) {
    let hours = date.getHours();
    if (hours === 0)
      hours = 24;
    if (token === "ko") {
      return localize2.ordinalNumber(hours, { unit: "hour" });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function(date, token, localize2) {
    if (token === "mo") {
      return localize2.ordinalNumber(date.getMinutes(), { unit: "minute" });
    }
    return lightFormatters.m(date, token);
  },
  // Second
  s: function(date, token, localize2) {
    if (token === "so") {
      return localize2.ordinalNumber(date.getSeconds(), { unit: "second" });
    }
    return lightFormatters.s(date, token);
  },
  // Fraction of second
  S: function(date, token) {
    return lightFormatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return "Z";
    }
    switch (token) {
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "XXXX":
      case "XX":
        return formatTimezone(timezoneOffset);
      case "XXXXX":
      case "XXX":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    switch (token) {
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "xxxx":
      case "xx":
        return formatTimezone(timezoneOffset);
      case "xxxxx":
      case "xxx":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (GMT)
  O: function(date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    switch (token) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "OOOO":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    switch (token) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "zzzz":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  // Seconds timestamp
  t: function(date, token, _localize) {
    const timestamp = Math.trunc(date.getTime() / 1e3);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function(date, token, _localize) {
    const timestamp = date.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, delimiter = "") {
  const sign = offset > 0 ? "-" : "+";
  const absOffset = Math.abs(offset);
  const hours = Math.trunc(absOffset / 60);
  const minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, delimiter) {
  if (offset % 60 === 0) {
    const sign = offset > 0 ? "-" : "+";
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, delimiter);
}
function formatTimezone(offset, delimiter = "") {
  const sign = offset > 0 ? "-" : "+";
  const absOffset = Math.abs(offset);
  const hours = addLeadingZeros(Math.trunc(absOffset / 60), 2);
  const minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
const dateLongFormatter = (pattern, formatLong2) => {
  switch (pattern) {
    case "P":
      return formatLong2.date({ width: "short" });
    case "PP":
      return formatLong2.date({ width: "medium" });
    case "PPP":
      return formatLong2.date({ width: "long" });
    case "PPPP":
    default:
      return formatLong2.date({ width: "full" });
  }
};
const timeLongFormatter = (pattern, formatLong2) => {
  switch (pattern) {
    case "p":
      return formatLong2.time({ width: "short" });
    case "pp":
      return formatLong2.time({ width: "medium" });
    case "ppp":
      return formatLong2.time({ width: "long" });
    case "pppp":
    default:
      return formatLong2.time({ width: "full" });
  }
};
const dateTimeLongFormatter = (pattern, formatLong2) => {
  const matchResult = pattern.match(/(P+)(p+)?/) || [];
  const datePattern = matchResult[1];
  const timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong2);
  }
  let dateTimeFormat;
  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong2.dateTime({ width: "short" });
      break;
    case "PP":
      dateTimeFormat = formatLong2.dateTime({ width: "medium" });
      break;
    case "PPP":
      dateTimeFormat = formatLong2.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong2.dateTime({ width: "full" });
      break;
  }
  return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong2)).replace("{{time}}", timeLongFormatter(timePattern, formatLong2));
};
const longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
const dayOfYearTokenRE = /^D+$/;
const weekYearTokenRE = /^Y+$/;
const throwTokens = ["D", "DD", "YY", "YYYY"];
function isProtectedDayOfYearToken(token) {
  return dayOfYearTokenRE.test(token);
}
function isProtectedWeekYearToken(token) {
  return weekYearTokenRE.test(token);
}
function warnOrThrowProtectedError(token, format2, input) {
  const _message = message(token, format2, input);
  console.warn(_message);
  if (throwTokens.includes(token))
    throw new RangeError(_message);
}
function message(token, format2, input) {
  const subject = token[0] === "Y" ? "years" : "days of the month";
  return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format2}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
function isDate(value) {
  return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
function isValid(date) {
  if (!isDate(date) && typeof date !== "number") {
    return false;
  }
  const _date = toDate(date);
  return !isNaN(Number(_date));
}
const formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
const longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const escapedStringRegExp = /^'([^]*?)'?$/;
const doubleQuoteRegExp = /''/g;
const unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function format(date, formatStr, options) {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const defaultOptions2 = getDefaultOptions();
  const locale = (options == null ? void 0 : options.locale) ?? defaultOptions2.locale ?? enUS;
  const firstWeekContainsDate = (options == null ? void 0 : options.firstWeekContainsDate) ?? ((_b = (_a = options == null ? void 0 : options.locale) == null ? void 0 : _a.options) == null ? void 0 : _b.firstWeekContainsDate) ?? defaultOptions2.firstWeekContainsDate ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.firstWeekContainsDate) ?? 1;
  const weekStartsOn = (options == null ? void 0 : options.weekStartsOn) ?? ((_f = (_e = options == null ? void 0 : options.locale) == null ? void 0 : _e.options) == null ? void 0 : _f.weekStartsOn) ?? defaultOptions2.weekStartsOn ?? ((_h = (_g = defaultOptions2.locale) == null ? void 0 : _g.options) == null ? void 0 : _h.weekStartsOn) ?? 0;
  const originalDate = toDate(date);
  if (!isValid(originalDate)) {
    throw new RangeError("Invalid time value");
  }
  let parts = formatStr.match(longFormattingTokensRegExp).map((substring) => {
    const firstCharacter = substring[0];
    if (firstCharacter === "p" || firstCharacter === "P") {
      const longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp).map((substring) => {
    if (substring === "''") {
      return { isToken: false, value: "'" };
    }
    const firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return { isToken: false, value: cleanEscapedString(substring) };
    }
    if (formatters[firstCharacter]) {
      return { isToken: true, value: substring };
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + firstCharacter + "`"
      );
    }
    return { isToken: false, value: substring };
  });
  if (locale.localize.preprocessor) {
    parts = locale.localize.preprocessor(originalDate, parts);
  }
  const formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale
  };
  return parts.map((part) => {
    if (!part.isToken)
      return part.value;
    const token = part.value;
    if (!(options == null ? void 0 : options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(token) || !(options == null ? void 0 : options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(token)) {
      warnOrThrowProtectedError(token, formatStr, String(date));
    }
    const formatter = formatters[token[0]];
    return formatter(originalDate, token, locale.localize, formatterOptions);
  }).join("");
}
function cleanEscapedString(input) {
  const matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}
function getDay(date) {
  const _date = toDate(date);
  const day = _date.getDay();
  return day;
}
function isAfter(date, dateToCompare) {
  const _date = toDate(date);
  const _dateToCompare = toDate(dateToCompare);
  return _date.getTime() > _dateToCompare.getTime();
}
function isBefore(date, dateToCompare) {
  const _date = toDate(date);
  const _dateToCompare = toDate(dateToCompare);
  return +_date < +_dateToCompare;
}
function isEqual(leftDate, rightDate) {
  const _dateLeft = toDate(leftDate);
  const _dateRight = toDate(rightDate);
  return +_dateLeft === +_dateRight;
}
function isSameMonth(dateLeft, dateRight) {
  const _dateLeft = toDate(dateLeft);
  const _dateRight = toDate(dateRight);
  return _dateLeft.getFullYear() === _dateRight.getFullYear() && _dateLeft.getMonth() === _dateRight.getMonth();
}
function startOfMonth(date) {
  const _date = toDate(date);
  _date.setDate(1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}
var H = { exports: {} }, j = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Re;
function ir() {
  return Re || (Re = 1, process$1.env.NODE_ENV !== "production" && function() {
    var N = React, P = Symbol.for("react.element"), V = Symbol.for("react.portal"), y = Symbol.for("react.fragment"), D = Symbol.for("react.strict_mode"), F = Symbol.for("react.profiler"), S = Symbol.for("react.provider"), h = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), R = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), g = Symbol.for("react.memo"), _ = Symbol.for("react.lazy"), A = Symbol.for("react.offscreen"), X = Symbol.iterator, Ce = "@@iterator";
    function Pe(e) {
      if (e === null || typeof e != "object")
        return null;
      var r = X && e[X] || e[Ce];
      return typeof r == "function" ? r : null;
    }
    var T = N.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function c(e) {
      {
        for (var r = arguments.length, t2 = new Array(r > 1 ? r - 1 : 0), n2 = 1; n2 < r; n2++)
          t2[n2 - 1] = arguments[n2];
        Se("error", e, t2);
      }
    }
    function Se(e, r, t2) {
      {
        var n2 = T.ReactDebugCurrentFrame, i2 = n2.getStackAddendum();
        i2 !== "" && (r += "%s", t2 = t2.concat([i2]));
        var u = t2.map(function(o) {
          return String(o);
        });
        u.unshift("Warning: " + r), Function.prototype.apply.call(console[e], console, u);
      }
    }
    var we = false, xe = false, je = false, ke = false, De = false, Z;
    Z = Symbol.for("react.module.reference");
    function Fe(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === y || e === F || De || e === D || e === R || e === d || ke || e === A || we || xe || je || typeof e == "object" && e !== null && (e.$$typeof === _ || e.$$typeof === g || e.$$typeof === S || e.$$typeof === h || e.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === Z || e.getModuleId !== void 0));
    }
    function Ae(e, r, t2) {
      var n2 = e.displayName;
      if (n2)
        return n2;
      var i2 = r.displayName || r.name || "";
      return i2 !== "" ? t2 + "(" + i2 + ")" : t2;
    }
    function Q(e) {
      return e.displayName || "Context";
    }
    function E(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && c("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case y:
          return "Fragment";
        case V:
          return "Portal";
        case F:
          return "Profiler";
        case D:
          return "StrictMode";
        case R:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case h:
            var r = e;
            return Q(r) + ".Consumer";
          case S:
            var t2 = e;
            return Q(t2._context) + ".Provider";
          case l:
            return Ae(e, e.render, "ForwardRef");
          case g:
            var n2 = e.displayName || null;
            return n2 !== null ? n2 : E(e.type) || "Memo";
          case _: {
            var i2 = e, u = i2._payload, o = i2._init;
            try {
              return E(o(u));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var m2 = Object.assign, w = 0, ee, re, te, ne, ae, oe, ie;
    function ue() {
    }
    ue.__reactDisabledLog = true;
    function Ie() {
      {
        if (w === 0) {
          ee = console.log, re = console.info, te = console.warn, ne = console.error, ae = console.group, oe = console.groupCollapsed, ie = console.groupEnd;
          var e = {
            configurable: true,
            enumerable: true,
            value: ue,
            writable: true
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        w++;
      }
    }
    function $e() {
      {
        if (w--, w === 0) {
          var e = {
            configurable: true,
            enumerable: true,
            writable: true
          };
          Object.defineProperties(console, {
            log: m2({}, e, {
              value: ee
            }),
            info: m2({}, e, {
              value: re
            }),
            warn: m2({}, e, {
              value: te
            }),
            error: m2({}, e, {
              value: ne
            }),
            group: m2({}, e, {
              value: ae
            }),
            groupCollapsed: m2({}, e, {
              value: oe
            }),
            groupEnd: m2({}, e, {
              value: ie
            })
          });
        }
        w < 0 && c("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var M = T.ReactCurrentDispatcher, U;
    function I(e, r, t2) {
      {
        if (U === void 0)
          try {
            throw Error();
          } catch (i2) {
            var n2 = i2.stack.trim().match(/\n( *(at )?)/);
            U = n2 && n2[1] || "";
          }
        return `
` + U + e;
      }
    }
    var B = false, $;
    {
      var We = typeof WeakMap == "function" ? WeakMap : Map;
      $ = new We();
    }
    function se(e, r) {
      if (!e || B)
        return "";
      {
        var t2 = $.get(e);
        if (t2 !== void 0)
          return t2;
      }
      var n2;
      B = true;
      var i2 = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var u;
      u = M.current, M.current = null, Ie();
      try {
        if (r) {
          var o = function() {
            throw Error();
          };
          if (Object.defineProperty(o.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(o, []);
            } catch (b) {
              n2 = b;
            }
            Reflect.construct(e, [], o);
          } else {
            try {
              o.call();
            } catch (b) {
              n2 = b;
            }
            e.call(o.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (b) {
            n2 = b;
          }
          e();
        }
      } catch (b) {
        if (b && n2 && typeof b.stack == "string") {
          for (var a = b.stack.split(`
`), v2 = n2.stack.split(`
`), s2 = a.length - 1, f = v2.length - 1; s2 >= 1 && f >= 0 && a[s2] !== v2[f]; )
            f--;
          for (; s2 >= 1 && f >= 0; s2--, f--)
            if (a[s2] !== v2[f]) {
              if (s2 !== 1 || f !== 1)
                do
                  if (s2--, f--, f < 0 || a[s2] !== v2[f]) {
                    var p = `
` + a[s2].replace(" at new ", " at ");
                    return e.displayName && p.includes("<anonymous>") && (p = p.replace("<anonymous>", e.displayName)), typeof e == "function" && $.set(e, p), p;
                  }
                while (s2 >= 1 && f >= 0);
              break;
            }
        }
      } finally {
        B = false, M.current = u, $e(), Error.prepareStackTrace = i2;
      }
      var C = e ? e.displayName || e.name : "", ye = C ? I(C) : "";
      return typeof e == "function" && $.set(e, ye), ye;
    }
    function Ye(e, r, t2) {
      return se(e, false);
    }
    function Le(e) {
      var r = e.prototype;
      return !!(r && r.isReactComponent);
    }
    function W(e, r, t2) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return se(e, Le(e));
      if (typeof e == "string")
        return I(e);
      switch (e) {
        case R:
          return I("Suspense");
        case d:
          return I("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case l:
            return Ye(e.render);
          case g:
            return W(e.type, r, t2);
          case _: {
            var n2 = e, i2 = n2._payload, u = n2._init;
            try {
              return W(u(i2), r, t2);
            } catch {
            }
          }
        }
      return "";
    }
    var Y = Object.prototype.hasOwnProperty, fe = {}, le = T.ReactDebugCurrentFrame;
    function L(e) {
      if (e) {
        var r = e._owner, t2 = W(e.type, e._source, r ? r.type : null);
        le.setExtraStackFrame(t2);
      } else
        le.setExtraStackFrame(null);
    }
    function Ne(e, r, t2, n2, i2) {
      {
        var u = Function.call.bind(Y);
        for (var o in e)
          if (u(e, o)) {
            var a = void 0;
            try {
              if (typeof e[o] != "function") {
                var v2 = Error((n2 || "React class") + ": " + t2 + " type `" + o + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[o] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw v2.name = "Invariant Violation", v2;
              }
              a = e[o](r, o, n2, t2, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (s2) {
              a = s2;
            }
            a && !(a instanceof Error) && (L(i2), c("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", n2 || "React class", t2, o, typeof a), L(null)), a instanceof Error && !(a.message in fe) && (fe[a.message] = true, L(i2), c("Failed %s type: %s", t2, a.message), L(null));
          }
      }
    }
    var Ve = Array.isArray;
    function q(e) {
      return Ve(e);
    }
    function Me(e) {
      {
        var r = typeof Symbol == "function" && Symbol.toStringTag, t2 = r && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return t2;
      }
    }
    function Ue(e) {
      try {
        return ce(e), false;
      } catch {
        return true;
      }
    }
    function ce(e) {
      return "" + e;
    }
    function ve(e) {
      if (Ue(e))
        return c("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Me(e)), ce(e);
    }
    var x = T.ReactCurrentOwner, Be = {
      key: true,
      ref: true,
      __self: true,
      __source: true
    }, de, pe, J;
    J = {};
    function qe(e) {
      if (Y.call(e, "ref")) {
        var r = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (r && r.isReactWarning)
          return false;
      }
      return e.ref !== void 0;
    }
    function Je(e) {
      if (Y.call(e, "key")) {
        var r = Object.getOwnPropertyDescriptor(e, "key").get;
        if (r && r.isReactWarning)
          return false;
      }
      return e.key !== void 0;
    }
    function Ge(e, r) {
      if (typeof e.ref == "string" && x.current && r && x.current.stateNode !== r) {
        var t2 = E(x.current.type);
        J[t2] || (c('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', E(x.current.type), e.ref), J[t2] = true);
      }
    }
    function ze(e, r) {
      {
        var t2 = function() {
          de || (de = true, c("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t2.isReactWarning = true, Object.defineProperty(e, "key", {
          get: t2,
          configurable: true
        });
      }
    }
    function Ke(e, r) {
      {
        var t2 = function() {
          pe || (pe = true, c("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t2.isReactWarning = true, Object.defineProperty(e, "ref", {
          get: t2,
          configurable: true
        });
      }
    }
    var He = function(e, r, t2, n2, i2, u, o) {
      var a = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: P,
        // Built-in properties that belong on the element
        type: e,
        key: r,
        ref: t2,
        props: o,
        // Record the component responsible for creating this element.
        _owner: u
      };
      return a._store = {}, Object.defineProperty(a._store, "validated", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      }), Object.defineProperty(a, "_self", {
        configurable: false,
        enumerable: false,
        writable: false,
        value: n2
      }), Object.defineProperty(a, "_source", {
        configurable: false,
        enumerable: false,
        writable: false,
        value: i2
      }), Object.freeze && (Object.freeze(a.props), Object.freeze(a)), a;
    };
    function Xe(e, r, t2, n2, i2) {
      {
        var u, o = {}, a = null, v2 = null;
        t2 !== void 0 && (ve(t2), a = "" + t2), Je(r) && (ve(r.key), a = "" + r.key), qe(r) && (v2 = r.ref, Ge(r, i2));
        for (u in r)
          Y.call(r, u) && !Be.hasOwnProperty(u) && (o[u] = r[u]);
        if (e && e.defaultProps) {
          var s2 = e.defaultProps;
          for (u in s2)
            o[u] === void 0 && (o[u] = s2[u]);
        }
        if (a || v2) {
          var f = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          a && ze(o, f), v2 && Ke(o, f);
        }
        return He(e, a, v2, i2, n2, x.current, o);
      }
    }
    var G = T.ReactCurrentOwner, ge = T.ReactDebugCurrentFrame;
    function O(e) {
      if (e) {
        var r = e._owner, t2 = W(e.type, e._source, r ? r.type : null);
        ge.setExtraStackFrame(t2);
      } else
        ge.setExtraStackFrame(null);
    }
    var z;
    z = false;
    function K(e) {
      return typeof e == "object" && e !== null && e.$$typeof === P;
    }
    function Ee() {
      {
        if (G.current) {
          var e = E(G.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function Ze(e) {
      {
        if (e !== void 0) {
          var r = e.fileName.replace(/^.*[\\\/]/, ""), t2 = e.lineNumber;
          return `

Check your code at ` + r + ":" + t2 + ".";
        }
        return "";
      }
    }
    var be = {};
    function Qe(e) {
      {
        var r = Ee();
        if (!r) {
          var t2 = typeof e == "string" ? e : e.displayName || e.name;
          t2 && (r = `

Check the top-level render call using <` + t2 + ">.");
        }
        return r;
      }
    }
    function he(e, r) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = true;
        var t2 = Qe(r);
        if (be[t2])
          return;
        be[t2] = true;
        var n2 = "";
        e && e._owner && e._owner !== G.current && (n2 = " It was passed a child from " + E(e._owner.type) + "."), O(e), c('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', t2, n2), O(null);
      }
    }
    function _e(e, r) {
      {
        if (typeof e != "object")
          return;
        if (q(e))
          for (var t2 = 0; t2 < e.length; t2++) {
            var n2 = e[t2];
            K(n2) && he(n2, r);
          }
        else if (K(e))
          e._store && (e._store.validated = true);
        else if (e) {
          var i2 = Pe(e);
          if (typeof i2 == "function" && i2 !== e.entries)
            for (var u = i2.call(e), o; !(o = u.next()).done; )
              K(o.value) && he(o.value, r);
        }
      }
    }
    function er(e) {
      {
        var r = e.type;
        if (r == null || typeof r == "string")
          return;
        var t2;
        if (typeof r == "function")
          t2 = r.propTypes;
        else if (typeof r == "object" && (r.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        r.$$typeof === g))
          t2 = r.propTypes;
        else
          return;
        if (t2) {
          var n2 = E(r);
          Ne(t2, e.props, "prop", n2, e);
        } else if (r.PropTypes !== void 0 && !z) {
          z = true;
          var i2 = E(r);
          c("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", i2 || "Unknown");
        }
        typeof r.getDefaultProps == "function" && !r.getDefaultProps.isReactClassApproved && c("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function rr(e) {
      {
        for (var r = Object.keys(e.props), t2 = 0; t2 < r.length; t2++) {
          var n2 = r[t2];
          if (n2 !== "children" && n2 !== "key") {
            O(e), c("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", n2), O(null);
            break;
          }
        }
        e.ref !== null && (O(e), c("Invalid attribute `ref` supplied to `React.Fragment`."), O(null));
      }
    }
    function me(e, r, t2, n2, i2, u) {
      {
        var o = Fe(e);
        if (!o) {
          var a = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (a += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var v2 = Ze(i2);
          v2 ? a += v2 : a += Ee();
          var s2;
          e === null ? s2 = "null" : q(e) ? s2 = "array" : e !== void 0 && e.$$typeof === P ? (s2 = "<" + (E(e.type) || "Unknown") + " />", a = " Did you accidentally export a JSX literal instead of a component?") : s2 = typeof e, c("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", s2, a);
        }
        var f = Xe(e, r, t2, i2, u);
        if (f == null)
          return f;
        if (o) {
          var p = r.children;
          if (p !== void 0)
            if (n2)
              if (q(p)) {
                for (var C = 0; C < p.length; C++)
                  _e(p[C], e);
                Object.freeze && Object.freeze(p);
              } else
                c("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _e(p, e);
        }
        return e === y ? rr(f) : er(f), f;
      }
    }
    function tr(e, r, t2) {
      return me(e, r, t2, true);
    }
    function nr(e, r, t2) {
      return me(e, r, t2, false);
    }
    var ar = nr, or = tr;
    j.Fragment = y, j.jsx = ar, j.jsxs = or;
  }()), j;
}
var k = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Te;
function ur() {
  if (Te)
    return k;
  Te = 1;
  var N = React, P = Symbol.for("react.element"), V = Symbol.for("react.fragment"), y = Object.prototype.hasOwnProperty, D = N.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, F = { key: true, ref: true, __self: true, __source: true };
  function S(h, l, R) {
    var d, g = {}, _ = null, A = null;
    R !== void 0 && (_ = "" + R), l.key !== void 0 && (_ = "" + l.key), l.ref !== void 0 && (A = l.ref);
    for (d in l)
      y.call(l, d) && !F.hasOwnProperty(d) && (g[d] = l[d]);
    if (h && h.defaultProps)
      for (d in l = h.defaultProps, l)
        g[d] === void 0 && (g[d] = l[d]);
    return { $$typeof: P, type: h, key: _, ref: A, props: g, _owner: D.current };
  }
  return k.Fragment = V, k.jsx = S, k.jsxs = S, k;
}
process$1.env.NODE_ENV === "production" ? H.exports = ur() : H.exports = ir();
var fr = H.exports;
const n$2 = ({
  title: l,
  titleId: o,
  ...r
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...r,
    children: [
      l ? /* @__PURE__ */ fr.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M333.538 513.105c0-10.923 4.16-21.824 12.501-30.165l269.44-269.44c16.661-16.661 43.691-16.661 60.331 0 16.683 16.661 16.683 43.669 0 60.331L436.535 513.106l239.189 239.189c16.661 16.661 16.661 43.669 0 60.331s-43.669 16.661-60.331 0L346.038 543.271c-8.341-8.341-12.501-19.243-12.501-30.165z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), m$1 = memo(n$2);
const n$1 = ({
  title: l,
  titleId: o,
  ...i2
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...i2,
    children: [
      l ? /* @__PURE__ */ fr.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M690.462 510.895c0 10.923-4.16 21.824-12.501 30.165L408.521 810.5c-16.661 16.661-43.691 16.661-60.331 0-16.683-16.661-16.683-43.669 0-60.331l239.275-239.275-239.189-239.189c-16.661-16.661-16.661-43.669 0-60.331s43.669-16.661 60.331 0l269.355 269.355c8.341 8.341 12.501 19.243 12.501 30.165z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), m = memo(n$1);
const v = ({
  title: h,
  titleId: e,
  ...l
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": e,
    ...l,
    children: [
      h ? /* @__PURE__ */ fr.jsx("title", { id: e, children: h }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M875.661 285.222c0-47.147-38.187-85.333-85.333-85.333h-12.373v-37.333a19.12 19.12 0 0 0-19.2-19.2h-57.6c-10.453 0-19.2 8.533-19.2 19.2v37.333h-339.2v-37.333a19.12 19.12 0 0 0-19.2-19.2h-57.6a19.12 19.12 0 0 0-19.2 19.2v37.333h-11.093c-47.147 0-85.333 38.187-85.333 85.333v52.053h725.333zM769.069 590.669c0 11.776-9.557 21.333-21.333 21.333h-64c-11.776 0-21.333-9.557-21.333-21.333v-64c0-11.776 9.557-21.333 21.333-21.333h64c11.776 0 21.333 9.557 21.333 21.333zm0 176c0 11.776-9.557 21.333-21.333 21.333h-64c-11.776 0-21.333-9.557-21.333-21.333v-64c0-11.776 9.557-21.333 21.333-21.333h64c11.776 0 21.333 9.557 21.333 21.333zm-202.006-176c0 11.776-9.557 21.333-21.333 21.333h-64c-11.776 0-21.333-9.557-21.333-21.333v-64c0-11.776 9.557-21.333 21.333-21.333h64c11.776 0 21.333 9.557 21.333 21.333zm0 176c0 11.776-9.557 21.333-21.333 21.333h-64c-11.776 0-21.333-9.557-21.333-21.333v-64c0-11.776 9.557-21.333 21.333-21.333h64c11.776 0 21.333 9.557 21.333 21.333zm-201.984-176c0 11.776-9.557 21.333-21.333 21.333h-64c-11.797 0-21.333-9.557-21.333-21.333v-64c0-11.776 9.536-21.333 21.333-21.333h64c11.776 0 21.333 9.557 21.333 21.333zm0 176c0 11.776-9.557 21.333-21.333 21.333h-64c-11.797 0-21.333-9.557-21.333-21.333v-64c0-11.776 9.536-21.333 21.333-21.333h64c11.776 0 21.333 9.557 21.333 21.333zM150.402 399.991v389.845c0 57.899 38.208 104.832 85.333 104.832h554.667c47.125 0 85.333-46.933 85.333-104.832V399.991z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), i = memo(v);
const colors = {
  // Base colours
  white: "#FFF",
  black: "#000",
  jumbo: "#7C7C80",
  catskillWhite: "#EEF3F6",
  porcelain: "#F3F4F5",
  athensGray: "#F9FAFB",
  // THEMES
  // Primary
  cornflowerBlue: "#5EA5EE",
  havelockBlue: "#5698DC",
  hawkesBlue: "#E4F0FC",
  mariner: "#2E71C1",
  // Secondary
  amethyst: "#BA69C8",
  wisteria: "#A55AB2",
  whiteLilac: "#F8F0F9",
  affair: "#974CA3",
  // Success
  jungleGreen: "#34B96F",
  eucalyptus: "#2FA765",
  harp: "#E1F1E7",
  seaGreen: "#229053",
  // Warning
  sandyBrown: "#F28F5D",
  burntSienna: "#E88857",
  provincialPink: "#FDF3EE",
  redDamask: "#D77644",
  // Error
  mandy: "#e25c59",
  chestnutRose: "#D05552",
  linen: "#FCEEEE",
  mojo: "#C24441",
  // Legacy
  scooter: "#40aadb",
  pelorous: "#3A99C4",
  whiteIce: "#D9EEF8",
  jellyBean: "#257FA8",
  // Light
  mystic: "#E4EBEF",
  geyser: "#DAE0E4",
  grayChateau: "#A6ACAF",
  scorpion: "#5C5C5C",
  // Dark
  oxfordBlue: "#343951",
  blueZodiac: "#0B1236",
  mischka: "#D3D5DF",
  blackPearl: "#060A22",
  // Tertiary
  froly: "#F96E8D",
  cranberry: "#E55D7B",
  wispPink: "#FCE6EA",
  cabaret: "#D54F6D",
  // Info
  shakespeare: "#41BFCB",
  bostonBlue: "#30A4AF",
  iceberg: "#D8F2F4",
  easternBlue: "#238F99"
};
const primaryTheme = {
  base: colors.cornflowerBlue,
  medium: colors.havelockBlue,
  light: colors.hawkesBlue,
  dark: colors.mariner
};
const secondaryTheme = {
  base: colors.amethyst,
  medium: colors.wisteria,
  light: colors.whiteLilac,
  dark: colors.affair
};
const successTheme = {
  base: colors.jungleGreen,
  medium: colors.eucalyptus,
  light: colors.harp,
  dark: colors.seaGreen
};
const warningTheme = {
  base: colors.sandyBrown,
  medium: colors.burntSienna,
  light: colors.provincialPink,
  dark: colors.redDamask
};
const errorTheme = {
  base: colors.mandy,
  medium: colors.chestnutRose,
  light: colors.linen,
  dark: colors.mojo
};
const legacyTheme = {
  base: colors.scooter,
  medium: colors.pelorous,
  light: colors.whiteIce,
  dark: colors.jellyBean
};
const lightTheme = {
  base: colors.grayChateau,
  medium: colors.geyser,
  light: colors.mystic,
  dark: colors.scorpion
};
const darkTheme = {
  base: colors.oxfordBlue,
  medium: colors.blueZodiac,
  light: colors.mischka,
  dark: colors.blackPearl
};
const tertiaryTheme = {
  base: colors.froly,
  medium: colors.cranberry,
  light: colors.wispPink,
  dark: colors.cabaret
};
const infoTheme = {
  base: colors.shakespeare,
  medium: colors.bostonBlue,
  light: colors.iceberg,
  dark: colors.easternBlue
};
const getThemeColors = (theme) => {
  switch (theme) {
    case "secondary":
      return secondaryTheme;
    case "success":
      return successTheme;
    case "warning":
      return warningTheme;
    case "error":
      return errorTheme;
    case "legacy":
      return legacyTheme;
    case "light":
      return lightTheme;
    case "dark":
      return darkTheme;
    case "tertiary":
      return tertiaryTheme;
    case "info":
      return infoTheme;
    default:
      return primaryTheme;
  }
};
const borderRadius = {
  extraLarge: 100,
  medium: 4,
  default: 3,
  small: 2
};
const spacing = {
  extraLarge: 40,
  large: 24,
  medium: 18,
  default: 12,
  small: 6,
  extraSmall: 3
};
const fontSize = {
  extraLarge: 30,
  large: 24,
  medium: 18,
  default: 16,
  small: 14,
  extraSmall: 12
};
const fontWeight = {
  thin: 100,
  extraLight: 200,
  light: 300,
  regular: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
  extraBold: 800,
  black: 900
};
const fontFamily = {
  heading: '"proxima-nova", Helvetica, Arial, sans-serif',
  body: '"proxima-nova", Helvetica, Arial, sans-serif'
};
const zIndex = {
  level1: 100,
  level2: 200,
  level3: 300,
  level4: 400,
  level5: 500,
  level6: 600,
  level7: 700,
  level8: 800,
  level9: 900,
  level10: 1e3
};
const shorthandHelper = (values, unit = "px") => {
  if (!values.length) {
    return "0px";
  }
  const isNumber = (value) => Number(value) === 0 || Number(value);
  return values.map((value) => `${value}${isNumber(value) ? unit : ""}`).join(" ");
};
const hexToRgba = (colorValue, opacity = 1) => {
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  const fullHexColour = colorValue.replace(shorthandRegex, (m2, r, g, b) => r + r + g + g + b + b);
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHexColour);
  const rgb = result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : { r: 0, g: 0, b: 0 };
  return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${opacity})`;
};
const styles$7 = {
  button: css({
    boxSizing: "border-box",
    cursor: "pointer",
    borderRadius: borderRadius.default,
    border: "1px solid transparent",
    color: colors.white,
    fontFamily: fontFamily.body,
    fontWeight: fontWeight.regular,
    fontSize: fontSize.default,
    lineHeight: 1.4,
    whiteSpace: "nowrap",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    "&:active": {
      boxShadow: `inset 0 1px 3px ${hexToRgba(colors.black, 0.1)}`
    },
    "&:focus": {
      outline: "none"
    },
    "&[disabled]": {
      opacity: 0.3,
      pointerEvents: "none"
    }
  })
};
const buttonVariant = (variant, theme) => {
  const themed = getThemeColors(theme);
  if (theme === "light") {
    switch (variant) {
      case "outlined":
        return css({
          color: colors.jumbo,
          borderColor: themed.light,
          backgroundColor: "transparent",
          "&:hover": {
            backgroundColor: hexToRgba(themed.light, 0.3),
            boxShadow: `0 2px 4px ${hexToRgba(colors.black, 0.1)}`
          },
          "&:focus": {
            boxShadow: `0 0 4px 2px ${hexToRgba(themed.medium, 0.5)}`
          },
          "&:active": {
            backgroundColor: hexToRgba(themed.light, 0.6)
          }
        });
      case "dashed":
        return css({
          color: colors.jumbo,
          borderColor: themed.light,
          borderStyle: "dashed",
          backgroundColor: "transparent",
          "&:hover": {
            backgroundColor: hexToRgba(themed.light, 0.3),
            boxShadow: `0 2px 4px ${hexToRgba(colors.black, 0.1)}`
          },
          "&:focus": {
            boxShadow: `0 0 4px 2px ${hexToRgba(themed.medium, 0.5)}`
          },
          "&:active": {
            backgroundColor: hexToRgba(themed.light, 0.6)
          }
        });
      default:
        return css({
          color: colors.jumbo,
          backgroundColor: themed.light,
          "&:hover": {
            backgroundColor: hexToRgba(themed.medium, 0.8),
            boxShadow: `0 2px 4px ${hexToRgba(colors.black, 0.15)}`
          },
          "&:focus": {
            boxShadow: `0 0 4px 2px ${hexToRgba(themed.base, 0.5)}`
          },
          "&:active": {
            backgroundColor: themed.medium
          }
        });
    }
  }
  switch (variant) {
    case "outlined":
      return css({
        color: themed.base,
        borderColor: themed.base,
        backgroundColor: "transparent",
        "&:hover": {
          backgroundColor: hexToRgba(themed.light, 0.8),
          boxShadow: `0 2px 4px ${hexToRgba(colors.black, 0.1)}`
        },
        "&:focus": {
          boxShadow: `0 0 4px 2px ${hexToRgba(themed.medium, 0.2)}`
        },
        "&:active": {
          backgroundColor: hexToRgba(themed.base, 0.25)
        }
      });
    case "dashed":
      return css({
        color: themed.base,
        borderColor: themed.base,
        borderStyle: "dashed",
        backgroundColor: "transparent",
        "&:hover": {
          backgroundColor: hexToRgba(themed.light, 0.8),
          boxShadow: `0 2px 4px ${hexToRgba(colors.black, 0.1)}`
        },
        "&:focus": {
          boxShadow: `0 0 4px 2px ${hexToRgba(themed.medium, 0.2)}`
        },
        "&:active": {
          backgroundColor: hexToRgba(themed.base, 0.25)
        }
      });
    default:
      return css({
        backgroundColor: themed.base,
        "&:hover": {
          backgroundColor: themed.medium,
          boxShadow: `0 2px 4px ${hexToRgba(colors.black, 0.1)}`
        },
        "&:focus": {
          boxShadow: `0 0 4px 2px ${hexToRgba(themed.medium, 0.5)}`
        },
        "&:active": {
          backgroundColor: themed.dark
        }
      });
  }
};
const buttonSize = (size) => {
  switch (size) {
    case "small":
      return css({
        height: 30,
        fontSize: fontSize.small,
        padding: shorthandHelper([spacing.small, spacing.default])
      });
    case "medium":
      return css({
        height: 40,
        lineHeight: 1,
        padding: shorthandHelper([spacing.small, spacing.medium])
      });
    default:
      return css({
        height: 35,
        padding: shorthandHelper([spacing.small, spacing.default])
      });
  }
};
const Button = ({ className = null, size = "", theme = "", variant = "default", label, ...props }) => /* @__PURE__ */ React.createElement("button", { className: cx(styles$7.button, className, buttonSize(size), buttonVariant(variant, theme)), ...props }, label);
Button.propTypes = {
  label: PropTypes.string.isRequired,
  type: PropTypes.string,
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "light", "dark", "tertiary", "info"]),
  size: PropTypes.oneOf(["", "default", "small", "medium"]),
  variant: PropTypes.oneOf(["", "default", "outlined", "dashed"]),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string
};
Button.defaultProps = {
  type: "button",
  theme: "primary",
  size: "default"
};
const styles$6 = {
  wrapper: css({
    display: "inline-flex",
    fontFamily: fontFamily.body,
    fontSize: fontSize.small,
    fontWeight: fontWeight.bold,
    lineHeight: 1.2,
    marginTop: spacing.extraSmall,
    color: colors.mandy
  })
};
const FormErrorMessage = ({ className, text }) => /* @__PURE__ */ React.createElement("small", { className: cx(styles$6.wrapper, className) }, text);
FormErrorMessage.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string
};
const styles$5 = {
  wrapper: css({
    display: "inline-flex",
    fontWeight: fontWeight.semiBold,
    fontSize: fontSize.small,
    fontFamily: fontFamily.body,
    lineHeight: 1.2,
    color: colors.jumbo,
    marginTop: spacing.extraSmall
  })
};
const FormHelpText = ({ text }) => /* @__PURE__ */ React.createElement("small", { className: styles$5.wrapper }, text);
FormHelpText.propTypes = {
  text: PropTypes.string.isRequired
};
const styles$4 = {
  wrapper: css({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
    userSelect: "none"
  })
};
const wrapperSize = (size) => css({
  width: size,
  height: size
});
const iconSize = (size) => css({
  maxWidth: size,
  maxHeight: size
});
const AccessibleIcon = ({ icon, title, size = fontSize.medium, color = colors.scorpion, className, ariaHidden = true }) => {
  const [iconObject, setIconObject] = useState({ type: null, icon: null });
  const ariaHiddenValue = !title && "true" || ariaHidden.toString();
  useEffect(() => {
    if (!icon)
      return;
    if (typeof icon === "string") {
      console.warn("AccessibleIcon", `Passing in strings to the icon prop is deprecated. You passed in "${icon}"`);
      return;
    }
    if (icon == null ? void 0 : icon.paths) {
      setIconObject({ type: "object", icon });
      return;
    }
    if (isValidElement(createElement(icon))) {
      setIconObject({ type: "zenicon" });
      return;
    }
    console.warn("AccessibleIcon", "icon prop should be an string, object with paths or a React component");
  }, [icon]);
  return Boolean(icon && iconObject.type) && /* @__PURE__ */ React.createElement("span", { className: cx(styles$4.wrapper, className, wrapperSize(size)) }, iconObject.type === "zenicon" ? /* @__PURE__ */ React.createElement(React.Fragment, null, createElement(icon, {
    title,
    color,
    fontSize: size,
    "aria-hidden": ariaHiddenValue
  })) : /* @__PURE__ */ React.createElement(
    "svg",
    {
      className: iconSize(size),
      fill: color,
      width: 1024,
      height: 1024,
      viewBox: "0 0 1024 1024",
      preserveAspectRatio: "xMidYMid meet",
      role: "img",
      "aria-hidden": ariaHiddenValue
    },
    Boolean(title) && /* @__PURE__ */ React.createElement("title", null, title),
    /* @__PURE__ */ React.createElement("path", { d: iconObject.icon.paths.join(" ") })
  ));
};
AccessibleIcon.propTypes = {
  title: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  className: PropTypes.string,
  ariaHidden: PropTypes.bool,
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.shape({})]).isRequired
};
const styles$3 = {
  wrapper: css({
    position: "relative",
    width: 240,
    fontFamily: fontFamily.body
  }),
  wrapperError: css({
    "&:focus-within > div:last-child": {
      borderColor: colors.mandy,
      boxShadow: `0 0 0 2px ${hexToRgba(colors.mandy, 0.25)}`
    }
  }),
  label: css({
    position: "relative",
    display: "flex",
    alignItems: "center",
    boxSizing: "border-box",
    height: 40,
    width: "100%",
    border: `1px solid ${colors.mystic}`,
    borderRadius: borderRadius.default,
    backgroundColor: colors.white,
    "&:focus": {
      outline: "none"
    },
    "&[readonly]": {
      pointerEvents: "none",
      cursor: "default",
      backgroundColor: colors.athensGray
    }
  }),
  openLabel: css({
    zIndex: zIndex.level6
  }),
  errorLabel: css({
    borderColor: colors.mandy,
    "&:focus": {
      borderColor: colors.mandy,
      boxShadow: `0 0 0 2px ${hexToRgba(colors.mandy, 0.25)}`
    },
    "&:focus-within": {
      borderColor: colors.mandy,
      boxShadow: `0 0 0 2px ${hexToRgba(colors.mandy, 0.25)}`
    }
  }),
  input: css({
    cursor: "pointer",
    boxSizing: "border-box",
    width: "100%",
    height: "100%",
    backgroundColor: "transparent",
    color: colors.jumbo,
    fontFamily: fontFamily.body,
    fontSize: fontSize.default,
    lineHeight: 1.2,
    padding: shorthandHelper([spacing.small, 42, spacing.small, spacing.default]),
    appearance: "none",
    border: "none",
    borderRadius: borderRadius.default,
    "&::placeholder": {
      color: colors.grayChateau,
      userSelect: "none"
    },
    "&:focus": {
      outline: "none"
    }
  }),
  icon: css({
    position: "absolute",
    right: 0,
    top: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    padding: shorthandHelper([0, spacing.default]),
    pointerEvents: "none"
  }),
  overlay: css({
    position: "fixed",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: zIndex.level5
  }),
  body: css({
    position: "absolute",
    top: 40,
    left: 0,
    right: 0,
    backgroundColor: colors.white,
    border: `1px solid ${colors.mystic}`,
    borderRadius: borderRadius.default,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    marginTop: -1,
    zIndex: zIndex.level6,
    userSelect: "none",
    fontSize: fontSize.default,
    "&:focus": {
      outline: "none"
    }
  }),
  calendarHeader: css({
    display: "flex",
    alignItems: "center",
    color: colors.oxfordBlue,
    padding: spacing.default,
    "& strong": {
      flex: 1,
      textAlign: "center"
    }
  }),
  calendarNavigation: css({
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 24,
    height: 24,
    borderRadius: "50%",
    "&:hover": {
      backgroundColor: colors.geyser
    }
  }),
  calendar: css({
    // Since calendar adds 6 on top and bottom, and header and footer add 12,
    // we need to reduce 6 from the calendar's top and bottom to have a combined of 12 on both sides
    marginTop: -spacing.small,
    marginBottom: -spacing.small,
    padding: shorthandHelper([0, spacing.small]),
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: shorthandHelper([0, spacing.small]),
    "& th": {
      width: "calc(100% / 7)",
      textAlign: "center",
      fontWeight: fontWeight.regular
    }
  }),
  day: css({
    textAlign: "center",
    color: colors.oxfordBlue
  }),
  dayOut: css({
    color: hexToRgba(colors.oxfordBlue, 0.4)
  }),
  dayDisabled: css({
    color: hexToRgba(colors.oxfordBlue, 0.4),
    pointerEvents: "none"
  }),
  dayWrapper: css({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    width: 24,
    height: 24,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: colors.mystic
    }
  }),
  dayWrapperOut: css({
    "&:hover": {
      backgroundColor: hexToRgba(colors.mystic, 0.5)
    }
  }),
  footer: css({
    display: "flex",
    padding: spacing.default,
    "& > *": {
      flex: 1,
      padding: `${spacing.small}px !important`
    },
    "& > * + *": {
      marginLeft: spacing.small
    }
  })
};
const wrapperTheme$2 = (theme) => {
  const themed = getThemeColors(theme);
  return css({
    "&:focus-within > div:last-child": {
      borderColor: themed.base,
      boxShadow: `0 0 0 2px ${hexToRgba(themed.base, 0.25)}`
    }
  });
};
const labelTheme$2 = (theme) => {
  const themed = getThemeColors(theme);
  return css({
    "&:focus": {
      borderColor: themed.base,
      boxShadow: `0 0 0 2px ${hexToRgba(themed.base, 0.25)}`
    }
  });
};
const dayTheme$1 = (theme, inMonth) => {
  const themed = getThemeColors(theme);
  return css({
    backgroundColor: hexToRgba(themed.base, inMonth ? 1 : 0.5),
    color: colors.white,
    fontWeight: fontWeight.bold,
    "&:hover": {
      backgroundColor: hexToRgba(themed.base, inMonth ? 1 : 0.5)
    }
  });
};
class DatePicker extends Component {
  constructor() {
    super(...arguments);
    // eslint-disable-next-line react/state-in-constructor
    __publicField(this, "state", {
      open: false,
      activeMonth: null,
      activeDate: null
    });
    __publicField(this, "adjustDateToRange", (date) => {
      const { minDate, maxDate } = this.props;
      let newDate = date;
      if (minDate && isBefore(date, minDate)) {
        newDate = minDate;
      }
      if (maxDate && isAfter(date, maxDate)) {
        newDate = maxDate;
      }
      return newDate;
    });
    __publicField(this, "selectDate", (date) => {
      const { input, onChange } = this.props;
      const newDate = this.adjustDateToRange(date);
      this.setState({ activeDate: newDate, activeMonth: newDate });
      const handler = input.onChange || onChange;
      if (handler)
        handler(newDate);
    });
    __publicField(this, "closePicker", (ev) => {
      this.setState({ open: false });
      const handler = this.props.input.onBlur || this.props.onBlur;
      if (handler)
        handler(ev);
    });
  }
  componentDidMount() {
    const { input, minDate, maxDate, onChange, ...props } = this.props;
    const value = input.value || props.value;
    let activeDate = value ? new Date(value) : /* @__PURE__ */ new Date();
    if (minDate || maxDate) {
      activeDate = this.adjustDateToRange(activeDate);
      const handler = input.onChange || onChange;
      if (value && handler)
        handler(activeDate);
    }
    this.setState({ activeMonth: activeDate, activeDate });
  }
  render() {
    const { open, activeMonth, activeDate } = this.state;
    const { meta, input, theme, className, helpText, tabIndex, readOnly, id, ...props } = this.props;
    const name = input.name || props.name;
    const errored = meta.touched && meta.error;
    const value = input.value || props.value;
    const formatter = props.formatter || format;
    const formattedValue = isValid(new Date(value)) ? formatter(value, "d MMMM yyyy") : "";
    const firstOfMonth = startOfMonth(activeMonth);
    const prevMonthDays = getDay(firstOfMonth);
    const firstDayInCalendar = addDays(firstOfMonth, -prevMonthDays);
    const weeks = new Array(differenceInCalendarWeeks(addMonths(firstOfMonth, 1), firstOfMonth) + 1 || 0).fill(new Array(7).fill(0));
    const calendarWeeks = weeks.map(
      (week, weekIndex) => week.map((_, dayInWeek) => {
        const date = addWeeks(addDays(firstDayInCalendar, dayInWeek), weekIndex);
        const beforeMinDate = props.minDate ? isBefore(startOfDay(date), startOfDay(props.minDate)) : false;
        const afterMaxDate = props.maxDate ? isAfter(endOfDay(date), endOfDay(props.maxDate)) : false;
        return {
          day: format(date, "d"),
          selected: isEqual(startOfDay(activeDate), startOfDay(date)) && !!value,
          inMonth: isSameMonth(activeMonth, date),
          disabled: beforeMinDate || afterMaxDate,
          ...!beforeMinDate && !afterMaxDate && {
            onClick: () => {
              this.selectDate(date);
            }
          }
        };
      })
    );
    return /* @__PURE__ */ React.createElement("div", { className: cx(styles$3.wrapper, className, wrapperTheme$2(theme), errored && styles$3.wrapperError) }, Boolean(open) && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: styles$3.body, tabIndex: "-1" }, /* @__PURE__ */ React.createElement("div", { className: styles$3.calendarHeader }, /* @__PURE__ */ React.createElement("div", { className: styles$3.calendarNavigation, onClick: () => this.setState({ activeMonth: addMonths(activeMonth, -1) }) }, /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: m$1, size: 20, color: colors.grayChateau })), /* @__PURE__ */ React.createElement("strong", null, format(activeMonth, "MMMM yyyy")), /* @__PURE__ */ React.createElement("div", { className: styles$3.calendarNavigation, onClick: () => this.setState({ activeMonth: addMonths(activeMonth, 1) }) }, /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: m, size: 20, color: colors.grayChateau }))), /* @__PURE__ */ React.createElement("table", { className: styles$3.calendar }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "Su"), /* @__PURE__ */ React.createElement("th", null, "Mo"), /* @__PURE__ */ React.createElement("th", null, "Tu"), /* @__PURE__ */ React.createElement("th", null, "We"), /* @__PURE__ */ React.createElement("th", null, "Th"), /* @__PURE__ */ React.createElement("th", null, "Fr"), /* @__PURE__ */ React.createElement("th", null, "Sa"))), /* @__PURE__ */ React.createElement("tbody", null, calendarWeeks.map((row, rowIndex) => /* @__PURE__ */ React.createElement("tr", { key: rowIndex }, row.map((cell, cellIndex) => /* @__PURE__ */ React.createElement("td", { key: cellIndex, className: cx(styles$3.day, cell.disabled && styles$3.dayDisabled, !cell.inMonth && styles$3.dayOut) }, /* @__PURE__ */ React.createElement(
      "span",
      {
        className: cx(
          styles$3.dayWrapper,
          !cell.inMonth && styles$3.dayWrapperOut,
          cell.selected && dayTheme$1(theme, cell.inMonth)
        ),
        onClick: cell.onClick
      },
      cell.day
    ))))))), /* @__PURE__ */ React.createElement("div", { className: styles$3.footer }, /* @__PURE__ */ React.createElement(Button, { theme, size: "small", label: "Today", variant: "outlined", onClick: () => this.selectDate(/* @__PURE__ */ new Date()) }), /* @__PURE__ */ React.createElement(Button, { theme, size: "small", label: "Done", onClick: () => this.closePicker() }))), /* @__PURE__ */ React.createElement("div", { className: styles$3.overlay, onClick: this.closePicker })), /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cx(styles$3.label, labelTheme$2(theme), open && styles$3.openLabel, errored && styles$3.errorLabel),
        tabIndex,
        readOnly,
        onClick: (ev) => {
          if (open) {
            this.closePicker();
            return;
          }
          this.setState({ open: true });
          const focusHandler = input.onFocus || props.onFocus;
          if (focusHandler)
            focusHandler(ev);
        }
      },
      /* @__PURE__ */ React.createElement(
        "input",
        {
          ...input,
          type: "text",
          className: styles$3.input,
          tabIndex: "-1",
          readOnly: true,
          name,
          id,
          value: formattedValue,
          placeholder: props.placeholder,
          onBlur: (ev) => ev.preventDefault()
        }
      ),
      /* @__PURE__ */ React.createElement("div", { className: styles$3.icon }, /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: i, size: 18, color: errored ? colors.mandy : colors.geyser }))
    ), Boolean(helpText && !errored) && /* @__PURE__ */ React.createElement(FormHelpText, { text: helpText }), Boolean(errored) && /* @__PURE__ */ React.createElement(FormErrorMessage, { text: meta.error }));
  }
}
DatePicker.propTypes = {
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string
  }),
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    name: PropTypes.string
  }),
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.string,
  tabIndex: PropTypes.string,
  readOnly: PropTypes.bool,
  helpText: PropTypes.string,
  formatter: PropTypes.func,
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "dark", "tertiary", "info"]),
  className: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  minDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
  maxDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object])
};
DatePicker.defaultProps = {
  meta: {},
  input: {},
  name: "",
  value: "",
  tabIndex: "0",
  theme: "primary"
};
function addMilliseconds(date, amount) {
  const timestamp = +toDate(date);
  return constructFrom(date, timestamp + amount);
}
function addHours(date, amount) {
  return addMilliseconds(date, amount * millisecondsInHour);
}
function addMinutes(date, amount) {
  return addMilliseconds(date, amount * millisecondsInMinute);
}
function getDate(date) {
  const _date = toDate(date);
  const dayOfMonth = _date.getDate();
  return dayOfMonth;
}
function getHours(date) {
  const _date = toDate(date);
  const hours = _date.getHours();
  return hours;
}
function getMinutes(date) {
  const _date = toDate(date);
  const minutes = _date.getMinutes();
  return minutes;
}
function getMonth(date) {
  const _date = toDate(date);
  const month = _date.getMonth();
  return month;
}
function getYear(date) {
  return toDate(date).getFullYear();
}
function setDate(date, dayOfMonth) {
  const _date = toDate(date);
  _date.setDate(dayOfMonth);
  return _date;
}
function setHours(date, hours) {
  const _date = toDate(date);
  _date.setHours(hours);
  return _date;
}
function setMinutes(date, minutes) {
  const _date = toDate(date);
  _date.setMinutes(minutes);
  return _date;
}
function getDaysInMonth(date) {
  const _date = toDate(date);
  const year = _date.getFullYear();
  const monthIndex = _date.getMonth();
  const lastDayOfMonth = constructFrom(date, 0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}
function setMonth(date, month) {
  const _date = toDate(date);
  const year = _date.getFullYear();
  const day = _date.getDate();
  const dateWithDesiredMonth = constructFrom(date, 0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  const daysInMonth = getDaysInMonth(dateWithDesiredMonth);
  _date.setMonth(month, Math.min(day, daysInMonth));
  return _date;
}
function setYear(date, year) {
  const _date = toDate(date);
  if (isNaN(+_date)) {
    return constructFrom(date, NaN);
  }
  _date.setFullYear(year);
  return _date;
}
const n = ({
  title: l,
  titleId: o,
  ...r
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...r,
    children: [
      l ? /* @__PURE__ */ fr.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M510.895 333.538c10.923 0 21.824 4.16 30.165 12.501l269.44 269.44c16.661 16.661 16.661 43.691 0 60.331-16.661 16.683-43.669 16.683-60.331 0L510.894 436.535 271.705 675.724c-16.661 16.661-43.669 16.661-60.331 0s-16.661-43.669 0-60.331l269.355-269.355c8.341-8.341 19.243-12.501 30.165-12.501z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), t$1 = memo(n);
const s = ({
  title: l,
  titleId: o,
  ...n2
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...n2,
    children: [
      l ? /* @__PURE__ */ fr.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M512.789 690.135c-10.923 0-21.824-4.16-30.165-12.501l-269.44-269.44c-16.661-16.661-16.661-43.669 0-60.331s43.669-16.661 60.331 0L512.79 587.138l239.189-239.189c16.661-16.661 43.669-16.661 60.331 0s16.661 43.691 0 60.352L542.955 677.634c-8.341 8.341-19.243 12.501-30.165 12.501z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), t = memo(s);
const roundMinutesToStep = (date, step) => {
  const minuteModule = getMinutes(date) % step;
  const minuteDifference = minuteModule < Math.ceil(step / 2) ? -minuteModule : step - minuteModule;
  return addMinutes(date, minuteDifference);
};
const styles$2 = {
  wrapper: css({
    boxSizing: "border-box",
    listStyle: "none",
    margin: 0,
    padding: 0,
    borderBottom: `1px solid ${colors.mystic}`,
    height: 35,
    fontSize: fontSize.small,
    display: "flex",
    backgroundColor: colors.athensGray,
    "& > * + *": {
      borderLeft: `1px solid ${colors.mystic}`
    }
  }),
  item: css({
    flex: 1,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    color: colors.jumbo,
    borderTop: "3px solid transparent",
    borderBottom: "3px solid transparent",
    "&:hover": {
      color: colors.oxfordBlue
    }
  })
};
const itemTheme = (theme) => {
  const themed = getThemeColors(theme);
  return css({
    color: colors.oxfordBlue,
    borderBottomColor: themed.base,
    backgroundColor: themed.light
  });
};
const PickerToggle = ({ theme, mode, selectMode }) => /* @__PURE__ */ React.createElement("ul", { className: styles$2.wrapper }, /* @__PURE__ */ React.createElement("li", { className: cx(styles$2.item, mode === "date" && itemTheme(theme)), onClick: () => selectMode("date") }, "Date"), /* @__PURE__ */ React.createElement("li", { className: cx(styles$2.item, mode === "time" && itemTheme(theme)), onClick: () => selectMode("time") }, "Time"));
PickerToggle.propTypes = {
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "dark", "tertiary", "info"]),
  mode: PropTypes.string,
  selectMode: PropTypes.func
};
const styles$1 = {
  wrapper: css({
    position: "relative",
    width: 240,
    fontFamily: fontFamily.body
  }),
  wrapperError: css({
    "&:focus-within > div:last-child": {
      borderColor: colors.mandy,
      boxShadow: `0 0 0 2px ${hexToRgba(colors.mandy, 0.25)}`
    }
  }),
  label: css({
    position: "relative",
    display: "flex",
    alignItems: "center",
    boxSizing: "border-box",
    height: 40,
    width: "100%",
    border: `1px solid ${colors.mystic}`,
    borderRadius: borderRadius.default,
    backgroundColor: colors.white,
    "&:focus": {
      outline: "none"
    },
    "&[readonly]": {
      pointerEvents: "none",
      cursor: "default",
      backgroundColor: colors.athensGray
    }
  }),
  openLabel: css({
    zIndex: zIndex.level6
  }),
  errorLabel: css({
    borderColor: colors.mandy,
    "&:focus": {
      borderColor: colors.mandy,
      boxShadow: `0 0 0 2px ${hexToRgba(colors.mandy, 0.25)}`
    },
    "&:focus-within": {
      borderColor: colors.mandy,
      boxShadow: `0 0 0 2px ${hexToRgba(colors.mandy, 0.25)}`
    }
  }),
  input: css({
    cursor: "pointer",
    boxSizing: "border-box",
    width: "100%",
    height: "100%",
    backgroundColor: "transparent",
    color: colors.jumbo,
    fontFamily: fontFamily.body,
    fontSize: fontSize.default,
    lineHeight: 1.2,
    padding: shorthandHelper([spacing.small, 42, spacing.small, spacing.default]),
    appearance: "none",
    border: "none",
    borderRadius: borderRadius.default,
    "&::placeholder": {
      color: colors.grayChateau,
      userSelect: "none"
    },
    "&:focus": {
      outline: "none"
    }
  }),
  icon: css({
    position: "absolute",
    right: 0,
    top: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    padding: shorthandHelper([0, spacing.default]),
    pointerEvents: "none"
  }),
  overlay: css({
    position: "fixed",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: zIndex.level5
  }),
  body: css({
    position: "absolute",
    top: 40,
    left: 0,
    right: 0,
    backgroundColor: colors.white,
    border: `1px solid ${colors.mystic}`,
    borderRadius: borderRadius.default,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    marginTop: -1,
    zIndex: zIndex.level6,
    fontSize: fontSize.default,
    userSelect: "none",
    "&:focus": {
      outline: "none"
    }
  }),
  calendarHeader: css({
    display: "flex",
    alignItems: "center",
    color: colors.oxfordBlue,
    padding: spacing.default,
    "& strong": {
      flex: 1,
      textAlign: "center",
      fontFamily: fontFamily.body
    }
  }),
  calendarNavigation: css({
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 24,
    height: 24,
    borderRadius: "50%",
    "&:hover": {
      backgroundColor: colors.geyser
    }
  }),
  calendar: css({
    // Since calendar adds 6 on top and bottom, and header and footer add 12,
    // we need to reduce 6 from the calendar's top and bottom to have a combined of 12 on both sides
    marginTop: -spacing.small,
    marginBottom: -spacing.small,
    padding: shorthandHelper([0, spacing.small]),
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: shorthandHelper([0, spacing.small]),
    "& th": {
      width: "calc(100% / 7)",
      textAlign: "center",
      fontWeight: fontWeight.regular
    }
  }),
  day: css({
    textAlign: "center",
    color: colors.oxfordBlue
  }),
  dayOut: css({
    color: hexToRgba(colors.oxfordBlue, 0.4)
  }),
  dayDisabled: css({
    color: hexToRgba(colors.oxfordBlue, 0.4),
    pointerEvents: "none"
  }),
  dayWrapper: css({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    width: 24,
    height: 24,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: colors.mystic
    }
  }),
  dayWrapperOut: css({
    "&:hover": {
      backgroundColor: hexToRgba(colors.mystic, 0.5)
    }
  }),
  footer: css({
    display: "flex",
    padding: spacing.default,
    "& > *": {
      flex: 1,
      padding: `${spacing.small}px !important`
    },
    "& > * + *": {
      marginLeft: spacing.small
    }
  }),
  clock: css({
    display: "flex",
    justifyContent: "center",
    marginTop: spacing.medium
  }),
  timeNavigation: css({
    textAlign: "center",
    cursor: "pointer"
  }),
  timeNavigationWrapper: css({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 24,
    height: 24,
    borderRadius: "50%",
    "&:hover": {
      backgroundColor: colors.geyser
    }
  }),
  time: css({
    fontSize: fontSize.large,
    fontWeight: fontWeight.semiBold,
    color: colors.oxfordBlue,
    textAlign: "center",
    padding: shorthandHelper([spacing.default, spacing.large]),
    width: 75,
    boxSizing: "border-box"
  }),
  timeDivider: css({
    fontSize: fontSize.extraLarge,
    color: colors.grayChateau
  })
};
const wrapperTheme$1 = (theme) => {
  const themed = getThemeColors(theme);
  return css({
    "&:focus-within > div:last-child": {
      borderColor: themed.base,
      boxShadow: `0 0 0 2px ${hexToRgba(themed.base, 0.25)}`
    }
  });
};
const labelTheme$1 = (theme) => {
  const themed = getThemeColors(theme);
  return css({
    "&:focus": {
      borderColor: themed.base,
      boxShadow: `0 0 0 2px ${hexToRgba(themed.base, 0.25)}`
    }
  });
};
const dayTheme = (theme, inMonth) => {
  const themed = getThemeColors(theme);
  return css({
    backgroundColor: hexToRgba(themed.base, inMonth ? 1 : 0.5),
    color: colors.white,
    fontWeight: fontWeight.bold,
    "&:hover": {
      backgroundColor: hexToRgba(themed.base, inMonth ? 1 : 0.5)
    }
  });
};
class DateTimePicker extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      open: false,
      activeMonth: null,
      activeDate: null,
      selecting: "date"
    });
    __publicField(this, "adjustDateToRange", (date) => {
      const { minDate, minuteStep, maxDate } = this.props;
      let newDate = date;
      if (minDate && isBefore(date, minDate)) {
        newDate = addMinutes(minDate, minuteStep / 2);
      }
      if (maxDate && isAfter(date, maxDate)) {
        newDate = addMinutes(maxDate, -minuteStep / 2);
      }
      const adjustedDate = roundMinutesToStep(newDate, minuteStep);
      return adjustedDate;
    });
    __publicField(this, "selectDate", (date) => {
      const { activeDate } = this.state;
      const { input, onChange } = this.props;
      const newDate = this.adjustDateToRange(setHours(setMinutes(date, getMinutes(activeDate)), getHours(activeDate)));
      this.setState({ activeDate: newDate, activeMonth: newDate });
      const handler = input.onChange || onChange;
      if (handler)
        handler(newDate);
    });
    __publicField(this, "selectTime", (time) => {
      const { activeDate } = this.state;
      const { input, onChange } = this.props;
      const newTime = this.adjustDateToRange(setYear(setMonth(setDate(time, getDate(activeDate)), getMonth(activeDate)), getYear(activeDate)));
      this.setState({ activeDate: newTime, activeMonth: newTime });
      const handler = input.onChange || onChange;
      if (handler)
        handler(newTime);
    });
    __publicField(this, "closePicker", (ev) => {
      this.setState({ open: false, selecting: "date" });
      const handler = this.props.input.onBlur || this.props.onBlur;
      if (handler)
        handler(ev);
    });
  }
  componentDidMount() {
    const { input, minDate, maxDate, minuteStep, onChange, ...props } = this.props;
    const value = input.value || props.value;
    const date = value ? new Date(value) : /* @__PURE__ */ new Date();
    let activeDate = roundMinutesToStep(date, minuteStep);
    if (minDate || maxDate) {
      activeDate = this.adjustDateToRange(activeDate);
      const handler = input.onChange || onChange;
      if (value && handler)
        handler(activeDate);
    }
    this.setState({ activeMonth: activeDate, activeDate });
  }
  render() {
    const { open, activeMonth, activeDate, selecting } = this.state;
    const { meta, input, theme, className, helpText, tabIndex, readOnly, minuteStep, ...props } = this.props;
    const name = input.name || props.name;
    const errored = meta.touched && meta.error;
    const value = input.value || props.value;
    const formatter = props.formatter || format;
    const formattedValue = isValid(new Date(value)) ? formatter(roundMinutesToStep(value, minuteStep), "yyyy-MM-dd HH:mm") : "";
    const firstOfMonth = startOfMonth(activeMonth);
    const prevMonthDays = getDay(firstOfMonth);
    const firstDayInCalendar = addDays(firstOfMonth, -prevMonthDays);
    const weeks = new Array(differenceInCalendarWeeks(addMonths(firstOfMonth, 1), firstOfMonth) + 1 || 0).fill(new Array(7).fill(0));
    const calendarWeeks = weeks.map(
      (week, weekIndex) => week.map((_, dayInWeek) => {
        const date = addWeeks(addDays(firstDayInCalendar, dayInWeek), weekIndex);
        const beforeMinDate = props.minDate ? isBefore(startOfDay(date), startOfDay(props.minDate)) : false;
        const afterMaxDate = props.maxDate ? isAfter(endOfDay(date), endOfDay(props.maxDate)) : false;
        return {
          day: format(date, "d"),
          selected: isEqual(startOfDay(activeDate), startOfDay(date)) && !!value,
          inMonth: isSameMonth(activeMonth, date),
          disabled: beforeMinDate || afterMaxDate,
          ...!beforeMinDate && !afterMaxDate && {
            onClick: () => {
              this.selectDate(date);
              this.setState({ selecting: "time" });
            }
          }
        };
      })
    );
    return /* @__PURE__ */ React.createElement("div", { className: cx(styles$1.wrapper, className, wrapperTheme$1(theme), errored && styles$1.wrapperError) }, Boolean(open) && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: styles$1.body, tabIndex: "-1" }, Boolean(selecting === "date") && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      PickerToggle,
      {
        theme,
        mode: "date",
        selectMode: (mode) => {
          this.setState({ selecting: mode });
          if (this.input)
            this.input.focus();
        }
      }
    ), /* @__PURE__ */ React.createElement("div", { className: styles$1.calendarHeader }, /* @__PURE__ */ React.createElement("div", { className: styles$1.calendarNavigation, onClick: () => this.setState({ activeMonth: addMonths(activeMonth, -1) }) }, /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: m$1, size: 20, color: colors.grayChateau })), /* @__PURE__ */ React.createElement("strong", null, format(activeMonth, "MMMM yyyy")), /* @__PURE__ */ React.createElement("div", { className: styles$1.calendarNavigation, onClick: () => this.setState({ activeMonth: addMonths(activeMonth, 1) }) }, /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: m, size: 20, color: colors.grayChateau }))), /* @__PURE__ */ React.createElement("table", { className: styles$1.calendar }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "Su"), /* @__PURE__ */ React.createElement("th", null, "Mo"), /* @__PURE__ */ React.createElement("th", null, "Tu"), /* @__PURE__ */ React.createElement("th", null, "We"), /* @__PURE__ */ React.createElement("th", null, "Th"), /* @__PURE__ */ React.createElement("th", null, "Fr"), /* @__PURE__ */ React.createElement("th", null, "Sa"))), /* @__PURE__ */ React.createElement("tbody", null, calendarWeeks.map((row, rowIndex) => /* @__PURE__ */ React.createElement("tr", { key: rowIndex }, row.map((cell, cellIndex) => /* @__PURE__ */ React.createElement(
      "td",
      {
        key: cellIndex,
        className: cx(styles$1.day, cell.disabled && styles$1.dayDisabled, !cell.inMonth && styles$1.dayOut)
      },
      /* @__PURE__ */ React.createElement(
        "span",
        {
          className: cx(
            styles$1.dayWrapper,
            !cell.inMonth && styles$1.dayWrapperOut,
            cell.selected && dayTheme(theme, cell.inMonth)
          ),
          onClick: cell.onClick
        },
        cell.day
      )
    )))))), /* @__PURE__ */ React.createElement("div", { className: styles$1.footer }, /* @__PURE__ */ React.createElement(Button, { theme, size: "small", label: "Today", variant: "outlined", onClick: () => this.selectDate(/* @__PURE__ */ new Date()) }), /* @__PURE__ */ React.createElement(Button, { theme, size: "small", label: "Done", onClick: () => this.closePicker() }))), Boolean(selecting === "time") && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      PickerToggle,
      {
        theme,
        mode: "time",
        selectMode: (mode) => {
          this.setState({ selecting: mode });
          if (this.input)
            this.input.focus();
        }
      }
    ), /* @__PURE__ */ React.createElement("div", { className: styles$1.clock }, /* @__PURE__ */ React.createElement("table", null, /* @__PURE__ */ React.createElement("tbody", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", { className: styles$1.timeNavigation }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: styles$1.timeNavigationWrapper,
        onClick: () => this.selectTime(addHours(activeDate, 1)),
        "aria-label": "increase by 1 hour"
      },
      /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: t$1, size: 22, color: colors.grayChateau })
    )), /* @__PURE__ */ React.createElement("td", null), /* @__PURE__ */ React.createElement("td", { className: styles$1.timeNavigation }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: styles$1.timeNavigationWrapper,
        onClick: () => this.selectTime(addMinutes(activeDate, minuteStep)),
        "aria-label": "increase by 15 minutes"
      },
      /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: t$1, size: 22, color: colors.grayChateau })
    ))), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", { className: styles$1.time }, format(activeDate, "HH")), /* @__PURE__ */ React.createElement("td", { className: styles$1.timeDivider }, ":"), /* @__PURE__ */ React.createElement("td", { className: styles$1.time }, format(activeDate, "mm"))), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", { className: styles$1.timeNavigation }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: styles$1.timeNavigationWrapper,
        onClick: () => this.selectTime(addHours(activeDate, -1)),
        "aria-label": "reduce by 1 hour"
      },
      /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: t, size: 22, color: colors.grayChateau })
    )), /* @__PURE__ */ React.createElement("td", null), /* @__PURE__ */ React.createElement("td", { className: styles$1.timeNavigation }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: styles$1.timeNavigationWrapper,
        onClick: () => this.selectTime(addMinutes(activeDate, -minuteStep)),
        "aria-label": "reduce by 15 minutes"
      },
      /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: t, size: 22, color: colors.grayChateau })
    )))))), /* @__PURE__ */ React.createElement("div", { className: styles$1.footer }, /* @__PURE__ */ React.createElement(
      Button,
      {
        theme,
        size: "small",
        label: "Now",
        variant: "outlined",
        onClick: () => this.selectTime(roundMinutesToStep(/* @__PURE__ */ new Date(), minuteStep))
      }
    ), /* @__PURE__ */ React.createElement(Button, { theme, size: "small", label: "Done", onClick: () => this.closePicker() })))), /* @__PURE__ */ React.createElement("div", { className: styles$1.overlay, onClick: this.closePicker })), /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cx(styles$1.label, labelTheme$1(theme), open && styles$1.openLabel, errored && styles$1.errorLabel),
        tabIndex,
        readOnly,
        onClick: (ev) => {
          if (open) {
            this.closePicker();
            return;
          }
          this.setState({ open: true });
          const focusHandler = input.onFocus || props.onFocus;
          if (focusHandler)
            focusHandler(ev);
        }
      },
      /* @__PURE__ */ React.createElement(
        "input",
        {
          ...input,
          type: "text",
          className: styles$1.input,
          tabIndex: "-1",
          readOnly: true,
          id: props.id,
          ref: (el) => this.input = el,
          name,
          value: formattedValue,
          placeholder: props.placeholder,
          onBlur: (ev) => ev.preventDefault()
        }
      ),
      /* @__PURE__ */ React.createElement("div", { className: styles$1.icon }, /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: i, size: 18, color: errored ? colors.mandy : colors.geyser }))
    ), Boolean(helpText && !errored) && /* @__PURE__ */ React.createElement(FormHelpText, { text: helpText }), Boolean(errored) && /* @__PURE__ */ React.createElement(FormErrorMessage, { text: meta.error }));
  }
}
DateTimePicker.propTypes = {
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string
  }),
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    name: PropTypes.string
  }),
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.string,
  tabIndex: PropTypes.string,
  readOnly: PropTypes.bool,
  helpText: PropTypes.string,
  formatter: PropTypes.func,
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "dark", "tertiary", "info"]),
  className: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  minuteStep: PropTypes.number,
  minDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
  maxDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
  id: PropTypes.string
};
DateTimePicker.defaultProps = {
  meta: {},
  input: {},
  name: "",
  value: "",
  tabIndex: "0",
  theme: "primary",
  minuteStep: 15
};
function addYears(date, amount) {
  return addMonths(date, amount * 12);
}
function endOfMonth(date) {
  const _date = toDate(date);
  const month = _date.getMonth();
  _date.setFullYear(_date.getFullYear(), month + 1, 0);
  _date.setHours(23, 59, 59, 999);
  return _date;
}
const styles = {
  wrapper: css({
    position: "relative",
    width: 240
  }),
  wrapperError: css({
    "&:focus-within > div:last-child": {
      borderColor: colors.mandy,
      boxShadow: `0 0 0 2px ${hexToRgba(colors.mandy, 0.25)}`
    }
  }),
  label: css({
    position: "relative",
    display: "flex",
    alignItems: "center",
    boxSizing: "border-box",
    height: 40,
    width: "100%",
    border: `1px solid ${colors.mystic}`,
    borderRadius: borderRadius.default,
    backgroundColor: colors.white,
    "&:focus": {
      outline: "none"
    },
    "&[readonly]": {
      pointerEvents: "none",
      cursor: "default",
      backgroundColor: colors.athensGray
    }
  }),
  openLabel: css({
    zIndex: zIndex.level6
  }),
  errorLabel: css({
    borderColor: colors.mandy,
    "&:focus": {
      borderColor: colors.mandy,
      boxShadow: `0 0 0 2px ${hexToRgba(colors.mandy, 0.25)}`
    },
    "&:focus-within": {
      borderColor: colors.mandy,
      boxShadow: `0 0 0 2px ${hexToRgba(colors.mandy, 0.25)}`
    }
  }),
  input: css({
    userSelect: "none",
    cursor: "pointer",
    boxSizing: "border-box",
    width: "100%",
    height: "100%",
    backgroundColor: "transparent",
    color: colors.jumbo,
    fontFamily: fontFamily.body,
    fontSize: fontSize.default,
    lineHeight: 1.2,
    padding: shorthandHelper([spacing.small, 42, spacing.small, spacing.default]),
    appearance: "none",
    border: "none",
    borderRadius: borderRadius.default,
    "&::placeholder": {
      color: colors.grayChateau,
      userSelect: "none"
    },
    "&:focus": {
      outline: "none"
    }
  }),
  icon: css({
    position: "absolute",
    right: 0,
    top: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    padding: shorthandHelper([0, spacing.default]),
    pointerEvents: "none"
  }),
  overlay: css({
    position: "fixed",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: zIndex.level5
  }),
  body: css({
    position: "absolute",
    top: 40,
    left: 0,
    right: 0,
    backgroundColor: colors.white,
    border: `1px solid ${colors.mystic}`,
    borderRadius: borderRadius.default,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    marginTop: -1,
    zIndex: zIndex.level6,
    userSelect: "none",
    "&:focus": {
      outline: "none"
    }
  }),
  calendarHeader: css({
    display: "flex",
    alignItems: "center",
    fontFamily: fontFamily.body,
    fontSize: fontSize.default,
    color: colors.oxfordBlue,
    padding: spacing.default,
    "& strong": {
      flex: 1,
      textAlign: "center"
    }
  }),
  calendarNavigation: css({
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 24,
    height: 24,
    borderRadius: "50%",
    "&:hover": {
      backgroundColor: colors.geyser
    }
  }),
  calendar: css({
    marginTop: -spacing.small,
    padding: shorthandHelper([0, spacing.small]),
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: shorthandHelper([0, spacing.small]),
    "& td": {
      width: "calc(100% / 3)"
    }
  }),
  month: css({
    textAlign: "center",
    fontFamily: fontFamily.body,
    fontSize: fontSize.default,
    color: colors.oxfordBlue
  }),
  monthDisabled: css({
    color: hexToRgba(colors.oxfordBlue, 0.4),
    pointerEvents: "none"
  }),
  monthWrapper: css({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    borderRadius: borderRadius.extraLarge,
    padding: shorthandHelper([spacing.extraSmall, spacing.default]),
    "&:hover": {
      backgroundColor: colors.mystic
    }
  }),
  footer: css({
    display: "flex",
    padding: spacing.default,
    "& > *": {
      flex: 1,
      padding: `${spacing.small}px !important`
    },
    "& > * + *": {
      marginLeft: spacing.small
    }
  })
};
const wrapperTheme = (theme) => {
  const themed = getThemeColors(theme);
  return css({
    "&:focus-within > div:last-child": {
      borderColor: themed.base,
      boxShadow: `0 0 0 2px ${hexToRgba(themed.base, 0.25)}`
    }
  });
};
const labelTheme = (theme) => {
  const themed = getThemeColors(theme);
  return css({
    "&:focus": {
      borderColor: themed.base,
      boxShadow: `0 0 0 2px ${hexToRgba(themed.base, 0.25)}`
    }
  });
};
const monthTheme = (theme) => {
  const themed = getThemeColors(theme);
  return css({
    backgroundColor: themed.base,
    color: colors.white,
    fontWeight: fontWeight.bold,
    "&:hover": {
      backgroundColor: themed.base
    }
  });
};
class MonthYearPicker extends Component {
  constructor() {
    super(...arguments);
    // eslint-disable-next-line react/state-in-constructor
    __publicField(this, "state", {
      open: false,
      activeYear: null,
      activeMonth: null
    });
    __publicField(this, "adjustDateToRange", (date) => {
      const { minDate, maxDate } = this.props;
      if (minDate && isBefore(date, minDate)) {
        return minDate;
      }
      if (maxDate && isAfter(date, maxDate)) {
        return maxDate;
      }
      return date;
    });
    __publicField(this, "closePicker", (ev) => {
      this.setState({ open: false });
      const handler = this.props.input.onBlur || this.props.onBlur;
      if (handler)
        handler(ev);
    });
    __publicField(this, "buildMonthCell", (monthNumber, value) => {
      const { activeMonth, activeYear } = this.state;
      const { minDate, maxDate } = this.props;
      const year = activeYear || /* @__PURE__ */ new Date();
      const date = new Date(addMonths(startOfYear(year), monthNumber));
      const monthStart = startOfMonth(date);
      const beforeMinDate = minDate ? isBefore(monthStart, startOfMonth(minDate)) : false;
      const afterMaxDate = maxDate ? isAfter(endOfMonth(date), endOfMonth(maxDate)) : false;
      return {
        month: format(date, "MMM"),
        selected: isEqual(startOfMonth(activeMonth), monthStart) && !!value,
        disabled: beforeMinDate || afterMaxDate,
        ...!beforeMinDate && !afterMaxDate && {
          onClick: () => this.selectDate(date)
        }
      };
    });
    __publicField(this, "selectDate", (date) => {
      const { input, onChange } = this.props;
      const handler = input.onChange || onChange;
      const newDate = this.adjustDateToRange(date);
      const dateWithoutTime = format(newDate, "yyyy-MM-dd");
      if (handler)
        handler(dateWithoutTime);
    });
  }
  componentDidMount() {
    const { input, minDate, maxDate, onChange, ...props } = this.props;
    const value = input.value || props.value;
    const date = value ? new Date(value) : /* @__PURE__ */ new Date();
    let activeMonth = date;
    if (minDate || maxDate) {
      activeMonth = this.adjustDateToRange(activeMonth);
      const handler = input.onChange || onChange;
      if (value && !isEqual(value, activeMonth) && handler)
        handler(activeMonth);
    }
    this.setState({ activeYear: activeMonth, activeMonth });
  }
  componentDidUpdate(prevProps) {
    const value = this.props.input.value || this.props.value;
    if (!value)
      return;
    const prevValue = prevProps.input.value || prevProps.value;
    if (value !== prevValue) {
      this.setState({ activeMonth: value, activeYear: value });
    }
  }
  render() {
    const { open, activeYear } = this.state;
    const { meta, input, theme, className, helpText, tabIndex, readOnly, innerRef, ...props } = this.props;
    const name = input.name || props.name;
    const errored = meta.touched && meta.error;
    const value = input.value || props.value;
    const formattedValue = isValid(new Date(value)) ? format(value, "MMMM, yyyy") : "";
    const calendarRows = [
      [0, 1, 2].map((monthNumber) => this.buildMonthCell(monthNumber, value)),
      [3, 4, 5].map((monthNumber) => this.buildMonthCell(monthNumber, value)),
      [6, 7, 8].map((monthNumber) => this.buildMonthCell(monthNumber, value)),
      [9, 10, 11].map((monthNumber) => this.buildMonthCell(monthNumber, value))
    ];
    return /* @__PURE__ */ React.createElement("div", { className: cx(styles.wrapper, className, wrapperTheme(theme), errored && styles.wrapperError) }, Boolean(open) && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: styles.body, tabIndex: "-1" }, /* @__PURE__ */ React.createElement("div", { className: styles.calendarHeader }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: styles.calendarNavigation,
        onClick: () => this.setState({ activeYear: addYears(activeYear, -1) }),
        "aria-label": "decrease by 1 year"
      },
      /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: m$1, size: 20, color: colors.grayChateau })
    ), /* @__PURE__ */ React.createElement("strong", null, format(activeYear, "yyyy")), /* @__PURE__ */ React.createElement(
      "div",
      {
        className: styles.calendarNavigation,
        onClick: () => this.setState({ activeYear: addYears(activeYear, 1) }),
        "aria-label": "increase by 1 year"
      },
      /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: m, size: 20, color: colors.grayChateau })
    )), /* @__PURE__ */ React.createElement("table", { className: styles.calendar }, /* @__PURE__ */ React.createElement("tbody", null, calendarRows.map((row, rowIndex) => /* @__PURE__ */ React.createElement("tr", { key: rowIndex }, row.map((cell, cellIndex) => /* @__PURE__ */ React.createElement("td", { key: cellIndex, className: cx(styles.month, cell.disabled && styles.monthDisabled) }, /* @__PURE__ */ React.createElement("span", { className: cx(styles.monthWrapper, cell.selected && monthTheme(theme)), onClick: cell.onClick }, cell.month))))))), /* @__PURE__ */ React.createElement("div", { className: styles.footer }, /* @__PURE__ */ React.createElement(Button, { theme, size: "small", label: "This month", variant: "outlined", onClick: () => this.selectDate(/* @__PURE__ */ new Date()) }), /* @__PURE__ */ React.createElement(Button, { theme, size: "small", label: "Done", onClick: () => this.closePicker() }))), /* @__PURE__ */ React.createElement("div", { className: styles.overlay, onClick: this.closePicker })), /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cx(styles.label, labelTheme(theme), open && styles.openLabel, errored && styles.errorLabel),
        tabIndex,
        readOnly,
        ref: innerRef,
        onClick: (ev) => {
          if (open) {
            this.closePicker(ev);
            return;
          }
          this.setState({ open: true });
          const focusHandler = input.onFocus || props.onFocus;
          if (focusHandler)
            focusHandler(ev);
        },
        "data-testid": "month-year-picker"
      },
      /* @__PURE__ */ React.createElement(
        "input",
        {
          ...input,
          type: "text",
          className: styles.input,
          tabIndex: "-1",
          readOnly: true,
          name,
          value: formattedValue,
          placeholder: props.placeholder,
          onFocus: (ev) => ev.preventDefault(),
          onBlur: (ev) => ev.preventDefault(),
          id: props.id
        }
      ),
      /* @__PURE__ */ React.createElement("div", { className: styles.icon }, /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: i, size: 18, color: errored ? colors.mandy : colors.geyser }))
    ), Boolean(helpText && !errored) && /* @__PURE__ */ React.createElement(FormHelpText, { text: helpText }), Boolean(errored) && /* @__PURE__ */ React.createElement(FormErrorMessage, { text: meta.error }));
  }
}
MonthYearPicker.propTypes = {
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string
  }),
  input: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    name: PropTypes.string
  }),
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.string,
  tabIndex: PropTypes.string,
  readOnly: PropTypes.bool,
  helpText: PropTypes.string,
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "dark", "tertiary", "info"]),
  className: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  minDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
  maxDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
  innerRef: PropTypes.func,
  id: PropTypes.string
};
MonthYearPicker.defaultProps = {
  meta: {},
  input: {},
  name: "",
  value: "",
  tabIndex: "0",
  theme: "primary"
};
export {
  DatePicker,
  DateTimePicker,
  MonthYearPicker
};
